import type { Variants } from '../types';

const metaDescriptionVariantTitles: Record<string, Variants> = {
	'/ca/tv-show/dtf-st-louis': 'V1',
	'/ca/tv-show/fallout': 'V2',
	'/ca/tv-show/56-days': 'V3',
	'/ca/tv-show/all-her-fault': 'V1',
	'/ca/tv-show/cross': 'V2',
	'/ca/tv-show/dark-winds': 'V3',
	'/ca/tv-show/day-one': 'V1',
	'/ca/tv-show/fargo': 'V2',
	'/ca/tv-show/9-1-1': 'V3',
	'/ca/tv-show/crap-happens': 'V1',
	'/ca/tv-show/alien': 'V2',
	'/ca/tv-show/americas-next-top-model': 'V3',
	'/ca/tv-show/abbott-elementary': 'V1',
	'/ca/tv-show/cia': 'V2',
	'/ca/tv-show/doctor-who': 'V3',
	'/ca/tv-show/chicago-fire': 'V1',
	'/ca/tv-show/esa-noche': 'V2',
	'/ca/tv-show/community': 'V3',
	'/ca/tv-show/breaking-bad': 'V1',
	'/ca/tv-show/dark': 'V2',
	'/ca/tv-show/family-guy': 'V3',
	'/ca/tv-show/fbi': 'V1',
	'/ca/tv-show/band-of-brothers': 'V2',
	'/ca/tv-show/brooklyn-nine-nine': 'V3',
	'/ca/tv-show/banshee': 'V1',
	'/ca/tv-show/chicago-med': 'V2',
	'/ca/tv-show/er': 'V3',
	'/ca/tv-show/falling-skies': 'V1',
	'/ca/tv-show/best-medicine': 'V2',
	'/ca/tv-show/agatha-christies-seven-dials': 'V3',
	'/ca/tv-show/beast-games': 'V1',
	'/ca/tv-show/all-creatures-great-and-small-2020': 'V2',
	'/ca/tv-show/evil': 'V3',
	'/ca/tv-show/doc': 'V1',
	'/ca/tv-show/dawsons-creek': 'V2',
	'/ca/tv-show/chicago-p-d': 'V3',
	'/ca/tv-show/elsbeth': 'V1',
	'/ca/tv-show/alone': 'V2',
	'/ca/tv-show/better-call-saul': 'V3',
	'/ca/tv-show/blue-lights': 'V1',
	'/ca/tv-show/babylon-5': 'V2',
	'/ca/tv-show/dexter-resurrection': 'V3',
	'/ca/tv-show/department-q': 'V1',
	'/ca/tv-show/dune-the-sisterhood': 'V2',
	'/ca/tv-show/12-monkeys': 'V3',
	'/ca/tv-show/adolescence-2025': 'V1',
	'/ca/tv-show/9-1-1-nashville': 'V2',
	'/ca/tv-show/bones': 'V3',
	'/ca/tv-show/animal-kingdom': 'V1',
	'/ca/tv-show/andor': 'V2',
	'/ca/tv-show/dynasty-the-murdochs': 'V3',
	'/ca/tv-show/arrow': 'V1',
	'/ca/tv-show/black-sails': 'V2',
	'/ca/tv-show/daredevil-born-again': 'V3',
	'/ca/tv-show/billions': 'V1',
	'/ca/tv-show/black-rabbit': 'V2',
	'/ca/tv-show/dirty-rotten-scandals': 'V3',
	'/ca/tv-show/barry': 'V1',
	'/ca/tv-show/arrested-development': 'V2',
	'/ca/tv-show/1883': 'V3',
	'/ca/tv-show/black-mirror': 'V1',
	'/ca/tv-show/age-of-attraction': 'V2',
	'/ca/tv-show/american-horror-story': 'V3',
	'/ca/tv-show/agents-of-mystery': 'V1',
	'/ca/tv-show/blue-therapy': 'V2',
	'/ca/tv-show/a-classic-spy': 'V3',
	'/ca/tv-show/avatar-the-last-airbender': 'V1',
	'/ca/tv-show/3-body-problem': 'V2',
	'/ca/tv-show/deadwood': 'V3',
	'/ca/tv-show/a-spy-among-friends': 'V1',
	'/ca/tv-show/beef': 'V2',
	'/ca/tv-show/down-cemetery-road': 'V3',
	'/ca/tv-show/broadchurch': 'V1',
	'/ca/tv-show/el-asesino-de-tiktok': 'V2',
	'/ca/tv-show/being-gordon-ramsay': 'V3',
	'/ca/tv-show/dark-matter-2024': 'V1',
	'/ca/tv-show/baki-do': 'V2',
	'/ca/tv-show/columbo': 'V3',
	'/ca/tv-show/charmed': 'V1',
	'/ca/tv-show/chad-powers': 'V2',
	'/ca/tv-show/batman-the-animated-series': 'V3',
	'/ca/tv-show/bobs-burgers': 'V1',
	'/ca/tv-show/beastars': 'V2',
	'/ca/tv-show/dragon-ball-z-1989': 'V3',
	'/ca/tv-show/c-b-strike-2017': 'V1',
	'/ca/tv-show/boardwalk-empire': 'V2',
	'/ca/tv-show/american-gods': 'V3',
	'/ca/tv-show/chuck': 'V1',
	'/ca/tv-show/dexter-new-blood': 'V2',
	'/ca/tv-show/a-discovery-of-witches': 'V3',
	'/ca/tv-show/dcs-legends-of-tomorrow': 'V1',
	'/ca/tv-show/bookish': 'V2',
	'/ca/tv-show/after-life': 'V3',
	'/ca/tv-show/bates-motel': 'V1',
	'/ca/tv-show/cowboy-bebop': 'V2',
	'/ca/tv-show/csi-crime-scene-investigation': 'V3',
	'/ca/tv-show/dying-for-sex': 'V1',
	'/ca/tv-show/dragon-ball': 'V2',
	'/ca/tv-show/bosch': 'V3',
	'/ca/tv-show/behind-her-eyes': 'V1',
	'/ca/tv-show/bleach': 'V2',
	'/ca/tv-show/boston-blue': 'V3',
	'/ca/tv-show/air-disasters': 'V1',
	'/ca/tv-show/blackbeard-2006': 'V2',
	'/ca/tv-show/ben-10': 'V3',
	'/ca/tv-show/elementary': 'V1',
	'/ca/tv-show/doc-martin': 'V2',
	'/ca/tv-show/farscape': 'V3',
	'/ca/tv-show/death-note': 'V1',
	'/ca/tv-show/a-thousand-blows': 'V2',
	'/ca/tv-show/ash-vs-evil-dead': 'V3',
	'/ca/tv-show/dexter-original-sin': 'V1',
	'/ca/tv-show/beverly-hills-90210': 'V2',
	'/ca/tv-show/brilliant-minds': 'V3',
	'/ca/tv-show/fear-the-walking-dead': 'V1',
	'/ca/tv-show/common-side-effects': 'V2',
	'/ca/tv-show/dragon-ball-super': 'V3',
	'/ca/tv-show/babylon-berlin': 'V1',
	'/ca/tv-show/blue-bloods': 'V2',
	'/ca/tv-show/american-dad': 'V3',
	'/ca/tv-show/bluey': 'V1',
	'/ca/tv-show/blue-mountain-state': 'V2',
	'/ca/tv-show/cosmos-a-spacetime-odyssey': 'V3',
	'/ca/tv-show/desperate-housewives': 'V1',
	'/ca/tv-show/devil-in-disguise-john-wayne-gacy': 'V2',
	'/ca/tv-show/black-clover': 'V3',
	'/ca/tv-show/bad-sisters': 'V1',
	'/ca/tv-show/fellow-travelers': 'V2',
	'/ca/tv-show/father-brown': 'V3',
	'/ca/tv-show/defending-jacob': 'V1',
	'/ca/tv-show/fbi-most-wanted': 'V2',
	'/ca/tv-show/chief-of-war': 'V3',
	'/ca/tv-show/el-eternauta': 'V1',
	'/ca/tv-show/astrid-et-raphaelle': 'V2',
	'/ca/tv-show/blackadder': 'V3',
	'/ca/tv-show/dead-like-me': 'V1',
	'/ca/tv-show/disclaimer': 'V2',
	'/ca/tv-show/atlanta': 'V3',
	'/ca/tv-show/everybody-loves-raymond': 'V1',
	'/ca/tv-show/boston-legal': 'V2',
	'/ca/tv-show/archer': 'V3',
	'/ca/tv-show/black-doves': 'V1',
	'/ca/tv-show/detective-conan': 'V2',
	'/ca/tv-show/3rd-rock-from-the-sun': 'V3',
	'/ca/tv-show/bojack-horseman': 'V1',
	'/ca/tv-show/film-club': 'V2',
	'/ca/tv-show/anne-rices-mayfair-witches': 'V3',
	'/ca/tv-show/1899': 'V1',
	'/ca/tv-show/brassic': 'V2',
	'/ca/tv-show/bridgerton-young-queen-charlotte-spinoff': 'V3',
	'/ca/tv-show/company-retreat': 'V1',
	'/ca/tv-show/ahsoka': 'V2',
	'/ca/tv-show/extracted': 'V3',
	'/ca/tv-show/alf': 'V1',
	'/ca/tv-show/cobra-kai': 'V2',
	'/ca/tv-show/dirk-gentlys-holistic-detective-agency': 'V3',
	'/ca/tv-show/entourage': 'V1',
	'/ca/tv-show/chained-soldier': 'V2',
	'/ca/tv-show/altered-carbon': 'V3',
	'/ca/tv-show/fauda': 'V1',
	'/ca/tv-show/couples-therapy-2019': 'V2',
	'/ca/tv-show/chainsaw-man': 'V3',
	'/ca/tv-show/doctor-foster': 'V1',
	'/ca/tv-show/and-then-there-were-none': 'V2',
	'/ca/tv-show/eastbound-and-down': 'V3',
	'/ca/tv-show/doom-patrol': 'V1',
	'/ca/tv-show/all-of-us-are-dead': 'V2',
	'/ca/tv-show/extraordinary': 'V3',
	'/ca/tv-show/dan-da-dan': 'V1',
	'/ca/tv-show/cold-case': 'V2',
	'/ca/tv-show/endeavour': 'V3',
	'/ca/tv-show/american-crime-story': 'V1',
	'/ca/tv-show/continuum': 'V2',
	'/ca/tv-show/dr-stone': 'V3',
	'/ca/tv-show/fear-factor-house-of-fear': 'V1',
	'/ca/tv-show/extras': 'V2',
	'/ca/tv-show/eureka': 'V3',
	'/ca/tv-show/alice-in-borderland': 'V1',
	'/ca/tv-show/critical-role-the-legend-of-vox-machina': 'V2',
	'/ca/tv-show/family-law-2021': 'V3',
	'/ca/tv-show/burn-notice': 'V1',
	'/ca/tv-show/empathie': 'V2',
	'/ca/tv-show/a-mothers-son': 'V3',
	'/ca/tv-show/a-teacher': 'V1',
	'/ca/tv-show/evil-lives-here': 'V2',
	'/ca/tv-show/cyberpunk-edgerunners': 'V3',
	'/ca/tv-show/cold-case-files-dead-west': 'V1',
	'/ca/tv-show/camelot': 'V2',
	'/ca/tv-show/9-1-1-lone-star': 'V3',
	'/ca/tv-show/batman': 'V1',
	'/ca/tv-show/detroiters': 'V2',
	'/ca/tv-show/csi-miami': 'V3',
	'/ca/tv-show/avatar-the-last-airbender-0': 'V1',
	'/ca/tv-show/dragon-ball-z-kai': 'V2',
	'/ca/tv-show/avenue-5': 'V3',
	'/ca/tv-show/can-this-love-be-translated': 'V1',
	'/ca/tv-show/earth-abides': 'V2',
	'/ca/tv-show/bodyguard': 'V3',
	'/ca/tv-show/daisy-jones-and-the-six': 'V1',
	'/ca/tv-show/countdown': 'V2',
	'/ca/tv-show/amadeus': 'V3',
	'/ca/tv-show/americas-culinary-cup': 'V1',
	'/ca/tv-show/catch-22': 'V2',
	'/ca/tv-show/beverly-hillbillies': 'V3',
	'/ca/tv-show/elite': 'V1',
	'/ca/tv-show/emily-in-paris': 'V2',
	'/ca/tv-show/drop-dead-diva': 'V3',
	'/ca/tv-show/dark-moon-the-blood-altar': 'V1',
	'/ca/tv-show/battlestar-galactica-1978': 'V2',
	'/ca/tv-show/better-off-ted': 'V3',
	'/ca/tv-show/borgen-power-and-glory': 'V1',
	'/ca/tv-show/90-day-the-single-life': 'V2',
	'/ca/tv-show/expedition-x': 'V3',
	'/ca/tv-show/da-vincis-demons': 'V1',
	'/ca/tv-show/debris': 'V2',
	'/ca/tv-show/anne': 'V3',
	'/ca/tv-show/dracula': 'V1',
	'/ca/tv-show/abandoned-engineering': 'V2',
	'/ca/tv-show/damages': 'V3',
	'/ca/tv-show/digimon-digital-monsters': 'V1',
	'/ca/tv-show/das-boot': 'V2',
	'/ca/tv-show/1000-lb-sisters': 'V3',
	'/ca/tv-show/baylen-out-loud': 'V1',
	'/ca/tv-show/everybody-hates-chris': 'V2',
	'/ca/tv-show/a-gentleman-in-moscow': 'V3',
	'/ca/tv-show/bull': 'V1',
	'/ca/tv-show/billy-the-kid': 'V2',
	'/ca/tv-show/designated-survivor': 'V3',
	'/ca/tv-show/code-geass-lelouch-of-the-rebellion': 'V1',
	'/ca/tv-show/below-deck': 'V2',
	'/ca/tv-show/belgravia': 'V3',
	'/ca/tv-show/dark-matter': 'V1',
	'/ca/tv-show/dickinson': 'V2',
	'/ca/tv-show/doc-in-your-hands': 'V3',
	'/ca/tv-show/dear-child': 'V1',
	'/ca/tv-show/a-murder-at-the-end-of-the-world': 'V2',
	'/ca/tv-show/dalgliesh-2021': 'V3',
	'/ca/tv-show/baby-reindeer': 'V1',
	'/ca/tv-show/fate-strange-fake': 'V2',
	'/ca/tv-show/born-to-bowl': 'V3',
	'/ca/tv-show/drawn-together': 'V1',
	'/ca/tv-show/carnival-row': 'V2',
	'/ca/tv-show/bloodhounds': 'V3',
	'/ca/tv-show/broad-city': 'V1',
	'/ca/tv-show/baki': 'V2',
	'/ca/tv-show/ben-10-alien-force': 'V3',
	'/ca/tv-show/dinosaurs': 'V1',
	'/ca/tv-show/armorsaurs': 'V2',
	'/ca/tv-show/el-encargado': 'V3',
	'/ca/tv-show/cash-queens': 'V1',
	'/ca/tv-show/fairy-tail': 'V2',
	'/ca/tv-show/dead-to-me': 'V3',
	'/ca/tv-show/berlin-station': 'V1',
	'/ca/tv-show/after-the-flood': 'V2',
	'/ca/tv-show/adults': 'V3',
	'/ca/tv-show/dr-quinn-medicine-woman': 'V1',
	'/ca/tv-show/australian-survivor': 'V2',
	'/ca/tv-show/bodkin': 'V3',
	'/ca/tv-show/channel-zero': 'V1',
	'/ca/tv-show/bluelock': 'V2',
	'/ca/tv-show/21-jump-street': 'V3',
	'/ca/tv-show/black-books': 'V1',
	'/ca/tv-show/creature-commandos': 'V2',
	'/ca/tv-show/castlevania': 'V3',
	'/ca/tv-show/agatha-christies-marple': 'V1',
	'/ca/tv-show/brave-new-world': 'V2',
	'/ca/tv-show/agatha-house-of-harkness': 'V3',
	'/ca/tv-show/alfred-hitchcock-presents': 'V1',
	'/ca/tv-show/dorohedoro': 'V2',
	'/ca/tv-show/daria': 'V3',
	'/ca/tv-show/darkness-those-who-kill': 'V1',
	'/ca/tv-show/brockmire': 'V2',
	'/ca/tv-show/crash-landing-on-you': 'V3',
	'/ca/tv-show/dispatches-from-elsewhere': 'V1',
	'/ca/tv-show/fbi-international': 'V2',
	'/ca/tv-show/dollhouse': 'V3',
	'/ca/tv-show/feud': 'V1',
	'/ca/tv-show/all-the-light-we-cannot-see': 'V2',
	'/ca/tv-show/animaniacs': 'V3',
	'/ca/tv-show/clarice': 'V1',
	'/ca/tv-show/dororo-2019': 'V2',
	'/ca/tv-show/andromeda': 'V3',
	'/ca/tv-show/charlottes-web': 'V1',
	'/ca/tv-show/based-on-a-true-story': 'V2',
	'/ca/tv-show/better-things': 'V3',
	'/ca/tv-show/emergencia-radioativa': 'V1',
	'/ca/tv-show/coldwater': 'V2',
	'/ca/tv-show/cougar-town': 'V3',
	'/ca/tv-show/carnivale': 'V1',
	'/ca/tv-show/butterfly-2025': 'V2',
	'/ca/tv-show/adventure-time-fionna-and-cake': 'V3',
	'/ca/tv-show/csi-ny': 'V1',
	'/ca/tv-show/below-deck-mediterranean': 'V2',
	'/ca/tv-show/dragon-ball-daima': 'V3',
	'/ca/tv-show/citadel': 'V1',
	'/ca/tv-show/american-horror-stories': 'V2',
	'/ca/tv-show/baywatch': 'V3',
	'/ca/tv-show/colony': 'V1',
	'/ca/tv-show/berlin': 'V2',
	'/ca/tv-show/boruto-naruto-next-generations': 'V3',
	'/ca/tv-show/bonappetit-your-majesty': 'V1',
	'/ca/tv-show/drake-and-josh': 'V2',
	'/ca/tv-show/constantine': 'V3',
	'/ca/tv-show/bleach-thousand-year-blood-war': 'V1',
	'/ca/tv-show/english-teacher': 'V2',
	'/ca/tv-show/billionaires-bunker': 'V3',
	'/ca/tv-show/black-snow': 'V1',
	'/ca/tv-show/an-idiot-abroad': 'V2',
	'/ca/tv-show/csi-vegas-2021': 'V3',
	'/ca/tv-show/90-day-fiance': 'V1',
	'/ca/tv-show/constellation': 'V2',
	'/ca/tv-show/episodes': 'V3',
	'/ca/tv-show/chapelwaite': 'V1',
	'/ca/tv-show/con-man': 'V2',
	'/ca/tv-show/all-american': 'V3',
	'/ca/tv-show/canada-shore': 'V1',
	'/ca/tv-show/30-coins': 'V2',
	'/ca/tv-show/90210': 'V3',
	'/ca/tv-show/farming-life-in-another-world': 'V1',
	'/ca/tv-show/billy-joel-and-so-it-goes': 'V2',
	'/ca/tv-show/farzi': 'V3',
	'/ca/tv-show/deutschland-83': 'V1',
	'/ca/tv-show/american-monster-abuse-of-power': 'V2',
	'/ca/tv-show/being-human': 'V3',
	'/ca/tv-show/batman-beyond': 'V1',
	'/ca/tv-show/black-summer': 'V2',
	'/ca/tv-show/condor': 'V3',
	'/ca/tv-show/ar-y-ffin': 'V1',
	'/ca/tv-show/father-matthew': 'V2',
	'/ca/tv-show/blaze-and-the-monster-machines': 'V3',
	'/ca/tv-show/big-mouth-2022': 'V1',
	'/ca/tv-show/american-monster': 'V2',
	'/ca/tv-show/akame-ga-kill': 'V3',
	'/ca/tv-show/covert-affairs': 'V1',
	'/ca/tv-show/boy-meets-world': 'V2',
	'/ca/tv-show/devious-maids': 'V3',
	'/ca/tv-show/candy': 'V1',
	'/ca/tv-show/bloodline': 'V2',
	'/ca/tv-show/creepshow': 'V3',
	'/ca/tv-show/ergo-proxy': 'V1',
	'/ca/tv-show/alchemy-of-souls': 'V2',
	'/ca/tv-show/bad-thoughts': 'V3',
	'/ca/tv-show/blackshore': 'V1',
	'/ca/tv-show/dead-set': 'V2',
	'/ca/tv-show/dexters-laboratory': 'V3',
	'/ca/tv-show/bar-rescue': 'V1',
	'/ca/tv-show/a-place-to-call-home': 'V2',
	'/ca/tv-show/criminal-record': 'V3',
	'/ca/tv-show/elfen-lied': 'V1',
	'/ca/tv-show/fallen': 'V2',
	'/ca/tv-show/alert-missing-persons-unit': 'V3',
	'/ca/tv-show/blanca': 'V1',
	'/ca/tv-show/boris': 'V2',
	'/ca/tv-show/dragon-ball-gt': 'V3',
	'/ca/tv-show/code-black': 'V1',
	'/ca/tv-show/alex-hugo': 'V2',
	'/ca/tv-show/coupling': 'V3',
	'/ca/tv-show/apple-cider-vinegar': 'V1',
	'/ca/tv-show/a-sorority-moms-guide-to-rush': 'V2',
	'/ca/tv-show/another-life': 'V3',
	'/ca/tv-show/deadliest-catch': 'V1',
	'/ca/tv-show/bonanza': 'V2',
	'/ca/tv-show/big-love': 'V3',
	'/ca/tv-show/documentary-now': 'V1',
	'/ca/tv-show/community-squad': 'V2',
	'/ca/tv-show/chappelles-show': 'V3',
	'/ca/tv-show/drommeren': 'V1',
	'/ca/tv-show/blue-exorcist': 'V2',
	'/ca/tv-show/a-million-little-things': 'V3',
	'/ca/tv-show/48-hours': 'V1',
	'/ca/tv-show/all-creatures-great-and-small': 'V2',
	'/ca/tv-show/final-siren-inside-the-afl': 'V3',
	'/ca/tv-show/easygoing-territory-defense-by-the-optimistic-lord': 'V1',
	'/ca/tv-show/fate-stay-night': 'V2',
	'/ca/tv-show/caprica': 'V3',
	'/ca/tv-show/ben-10-omniverse': 'V1',
	'/ca/tv-show/anderson-spider-silva': 'V2',
	'/ca/tv-show/final-space': 'V3',
	'/ca/tv-show/cruel-summer': 'V1',
	'/ca/tv-show/blade-runner-black-lotus': 'V2',
	'/ca/tv-show/blood-drive': 'V3',
	'/ca/tv-show/expedition-unknown': 'V1',
	'/ca/tv-show/culinary-class-wars': 'V2',
	'/ca/tv-show/dora-the-explorer': 'V3',
	'/ca/tv-show/allegiance-2024': 'V1',
	'/ca/tv-show/clickbait-2021': 'V2',
	'/ca/tv-show/exit-2019': 'V3',
	'/ca/tv-show/assassination-classroom': 'V1',
	'/ca/tv-show/a-p-bio': 'V2',
	'/ca/tv-show/captain-tsubasa': 'V3',
	'/ca/tv-show/departure': 'V1',
	'/ca/tv-show/coroner': 'V2',
	'/ca/tv-show/daddy-issues': 'V3',
	'/ca/tv-show/danger-5': 'V1',
	'/ca/tv-show/ben-10-ultimate-alien': 'V2',
	'/ca/tv-show/eva-lasting': 'V3',
	'/ca/tv-show/emma': 'V1',
	'/ca/tv-show/7th-heaven': 'V2',
	'/ca/tv-show/accused': 'V3',
	'/ca/tv-show/ballers': 'V1',
	'/ca/tv-show/calls-2021': 'V2',
	'/ca/tv-show/drunk-history-2013': 'V3',
	'/ca/tv-show/baskets': 'V1',
	'/ca/tv-show/beavis-and-butt-head': 'V2',
	'/ca/tv-show/ed-edd-n-eddy': 'V3',
	'/ca/tv-show/envious': 'V1',
	'/ca/tv-show/cashero': 'V2',
	'/ca/tv-show/death-comes-to-pemberley': 'V3',
	'/ca/tv-show/f4-thailand-boys-over-flowers': 'V1',
	'/ca/tv-show/dead-account': 'V2',
	'/ca/tv-show/corner-gas': 'V3',
	'/ca/tv-show/boiling-point': 'V1',
	'/ca/tv-show/death-parade': 'V2',
	'/ca/tv-show/american-idol-the-search-for-a-superstar': 'V3',
	'/ca/tv-show/as-you-stood-by': 'V1',
	'/ca/tv-show/dreamworks-dragons': 'V2',
	'/ca/tv-show/duster': 'V3',
	'/ca/tv-show/echo': 'V1',
	'/ca/tv-show/arifureta-from-commonplace-to-worlds-strongest': 'V2',
	'/ca/tv-show/fate-stay-night-unlimited-blade-works': 'V3',
	'/ca/tv-show/diablo-guardian': 'V1',
	'/ca/tv-show/el-marginal': 'V2',
	'/ca/tv-show/archangel': 'V3',
	'/ca/tv-show/are-you-afraid-of-the-dark': 'V1',
	'/ca/tv-show/cardcaptor-sakura': 'V2',
	'/ca/tv-show/exterior-night': 'V3',
	'/ca/tv-show/bungo-stray-dogs': 'V1',
	'/ca/tv-show/fate-zero': 'V2',
	'/ca/tv-show/crashing': 'V3',
	'/ca/tv-show/danganronpa-the-animation': 'V1',
	'/ca/tv-show/england-from-the-fall-of-rome-to-the-norman-conquest': 'V2',
	'/ca/tv-show/blues-clues-and-you': 'V3',
	'/ca/tv-show/big-time-rush': 'V1',
	'/ca/tv-show/el-juego-de-las-llaves': 'V2',
	'/ca/tv-show/a-haunting': 'V3',
	'/ca/tv-show/3': 'V1',
	'/ca/tv-show/bored-to-death': 'V2',
	'/ca/tv-show/dead-ringers': 'V3',
	'/ca/tv-show/dungeons-and-dragons': 'V1',
	'/ca/tv-show/amazing-stories-2020': 'V2',
	'/ca/tv-show/bad-judge': 'V3',
	'/ca/tv-show/el-internado': 'V1',
	'/ca/tv-show/benza-english': 'V2',
	'/ca/tv-show/30-for-30': 'V3',
	'/ca/tv-show/all-hail-king-julien': 'V1',
	'/ca/tv-show/bottom': 'V2',
	'/ca/tv-show/alias-grace': 'V3',
	'/ca/tv-show/baby': 'V1',
	'/ca/tv-show/cunk-on-earth': 'V2',
	'/ca/tv-show/des-2020': 'V3',
	'/ca/tv-show/dusk-beyond-the-end-of-the-world': 'V1',
	'/ca/tv-show/brideshead-revisited': 'V2',
	'/ca/tv-show/etoile': 'V3',
	'/ca/tv-show/early-edition': 'V1',
	'/ca/tv-show/dos-tumbas': 'V2',
	'/ca/tv-show/arthur': 'V3',
	'/ca/tv-show/all-the-queens-men': 'V1',
	'/ca/tv-show/bob-the-builder': 'V2',
	'/ca/tv-show/descendants-of-the-sun': 'V3',
	'/ca/tv-show/american-prince-jfk-jr': 'V1',
	'/ca/tv-show/castlevania-nocturne': 'V2',
	'/ca/tv-show/cardinal': 'V3',
	'/ca/tv-show/a-remarkable-place-to-die': 'V1',
	'/ca/tv-show/extraordinary-attorney-woo': 'V2',
	'/ca/tv-show/big-brother': 'V3',
	'/ca/tv-show/arctic-circle': 'V1',
	'/ca/tv-show/dr-death': 'V2',
	'/ca/tv-show/cats-eye': 'V3',
	'/ca/tv-show/8-out-of-10-cats-does-countdown': 'V1',
	'/ca/tv-show/empire': 'V2',
	'/ca/tv-show/angie-tribeca': 'V3',
	'/ca/tv-show/ben-and-hollys-little-kingdom': 'V1',
	'/ca/tv-show/batman-caped-crusader': 'V2',
	'/ca/tv-show/dragons-race-to-the-edge': 'V3',
	'/ca/tv-show/face-off': 'V1',
	'/ca/tv-show/big-shot': 'V2',
	'/ca/tv-show/86-eighty-six': 'V3',
	'/ca/tv-show/candice-renoir': 'V1',
	'/ca/tv-show/city-on-a-hill': 'V2',
	'/ca/tv-show/c-the-money-of-soul-and-possibility-control': 'V3',
	'/ca/tv-show/art-of-crime': 'V1',
	'/ca/tv-show/catherine-the-great': 'V2',
	'/ca/tv-show/awkward': 'V3',
	'/ca/tv-show/an-adventurers-daily-grind-at-age-29': 'V1',
	'/ca/tv-show/dont-f-k-with-cats-hunting-an-internet-killer': 'V2',
	'/ca/tv-show/a-small-light': 'V3',
	'/ca/tv-show/crossing-jordan': 'V1',
	'/ca/tv-show/crusoe': 'V2',
	'/ca/tv-show/dirty-john': 'V3',
	'/ca/tv-show/blues-clues': 'V1',
	'/ca/tv-show/a-young-doctors-notebook': 'V2',
	'/ca/tv-show/crime-in-progress': 'V3',
	'/ca/tv-show/banana-fish': 'V1',
	'/ca/tv-show/clannad': 'V2',
	'/ca/tv-show/doctor-odyssey': 'V3',
	'/ca/tv-show/boy-swallows-universe': 'V1',
	'/ca/tv-show/almas-not-normal': 'V2',
	'/ca/tv-show/black-butler': 'V3',
	'/ca/tv-show/being-human-2011': 'V1',
	'/ca/tv-show/charlies-angels': 'V2',
	'/ca/tv-show/asia-2024': 'V3',
	'/ca/tv-show/borgia': 'V1',
	'/ca/tv-show/dear-x': 'V2',
	'/ca/tv-show/angels-in-america': 'V3',
	'/ca/tv-show/blakes-7': 'V1',
	'/ca/tv-show/colin-in-black-and-white': 'V2',
	'/ca/tv-show/chopped': 'V3',
	'/ca/tv-show/blue-planet-ii': 'V1',
	'/ca/tv-show/bookie': 'V2',
	'/ca/tv-show/60-days-in': 'V3',
	'/ca/tv-show/claymore': 'V1',
	'/ca/tv-show/digman': 'V2',
	'/ca/tv-show/american-pickers': 'V3',
	'/ca/tv-show/alice-and-jack': 'V1',
	'/ca/tv-show/cable-girls': 'V2',
	'/ca/tv-show/4-blocks': 'V3',
	'/ca/tv-show/death-valley-2025': 'V1',
	'/ca/tv-show/a-touch-of-cloth': 'V2',
	'/ca/tv-show/clifford-the-big-red-dog': 'V3',
	'/ca/tv-show/beyblade-x': 'V1',
	'/ca/tv-show/dr-romantic': 'V2',
	'/ca/tv-show/ducktales': 'V3',
	'/ca/tv-show/blood-of-zeus': 'V1',
	'/ca/tv-show/dublin-murders': 'V2',
	'/ca/tv-show/deception-2018': 'V3',
	'/ca/tv-show/blue-spring-ride': 'V1',
	'/ca/tv-show/chesapeake-shores': 'V2',
	'/ca/tv-show/boss': 'V3',
	'/ca/tv-show/americas-funniest-home-videos': 'V1',
	'/ca/tv-show/find-me-in-paris': 'V2',
	'/ca/tv-show/derek': 'V3',
	'/ca/tv-show/black-lightning': 'V1',
	'/ca/tv-show/blue-heelers': 'V2',
	'/ca/tv-show/el-barco': 'V3',
	'/ca/tv-show/family-matters-2024': 'V1',
	'/ca/tv-show/diagnosis-murder': 'V2',
	'/ca/tv-show/agatha-raisin': 'V3',
	'/ca/tv-show/better-than-us': 'V1',
	'/ca/tv-show/fate-the-winx-saga': 'V2',
	'/ca/tv-show/dark-woods': 'V3',
	'/ca/tv-show/encounter': 'V1',
	'/ca/tv-show/american-gothic': 'V2',
	'/ca/tv-show/disenchantment': 'V3',
	'/ca/tv-show/conan-obrien-must-go': 'V1',
	'/ca/tv-show/bob-abishola': 'V2',
	'/ca/tv-show/bleak-house': 'V3',
	'/ca/tv-show/eyewitness-2016': 'V1',
	'/ca/tv-show/9-11-one-day-in-america': 'V2',
	'/ca/tv-show/another': 'V3',
	'/ca/tv-show/deadwater-fell': 'V1',
	'/ca/tv-show/cranford': 'V2',
	'/ca/tv-show/apple-tree-yard': 'V3',
	'/ca/tv-show/bitten': 'V1',
	'/ca/tv-show/crime': 'V2',
	'/ca/tv-show/art-detectives': 'V3',
	'/ca/tv-show/90-day-fiance-the-other-way': 'V1',
	'/ca/tv-show/afro-samurai': 'V2',
	'/ca/tv-show/alone-australia': 'V3',
	'/ca/tv-show/aqua-teen-hunger-force': 'V1',
	'/ca/tv-show/casualty': 'V2',
	'/ca/tv-show/dc-super-hero-girls': 'V3',
	'/ca/tv-show/city-confidential': 'V1',
	'/ca/tv-show/a-french-village': 'V2',
	'/ca/tv-show/60-minutes': 'V3',
	'/ca/tv-show/fatal-attraction': 'V1',
	'/ca/tv-show/batman-the-brave-and-the-bold': 'V2',
	'/ca/tv-show/conan-the-boy-in-future': 'V3',
	'/ca/tv-show/captain-planet-and-the-planeteers': 'V1',
	'/ca/tv-show/danny-phantom': 'V2',
	'/ca/tv-show/anger-management': 'V3',
	'/ca/tv-show/africa': 'V1',
	'/ca/tv-show/aka-charlie-sheen': 'V2',
	'/ca/tv-show/ben-10-reboot': 'V3',
	'/ca/tv-show/blossom': 'V1',
	'/ca/tv-show/emmerdale': 'V2',
	'/ca/tv-show/dynasty-2017': 'V3',
	'/ca/tv-show/family-by-choice': 'V1',
	'/ca/tv-show/fake-profile': 'V2',
	'/ca/tv-show/echoes-2022': 'V3',
	'/ca/tv-show/chewing-gum': 'V1',
	'/ca/tv-show/dreaming-whilst-black': 'V2',
	'/ca/tv-show/bordertown-2016': 'V3',
	'/ca/tv-show/csi-cyber': 'V1',
	'/ca/tv-show/farina': 'V2',
	'/ca/tv-show/all-heart': 'V3',
	'/ca/tv-show/beyblade': 'V1',
	'/ca/tv-show/cain': 'V2',
	'/ca/tv-show/breeders': 'V3',
	'/ca/tv-show/alex-rider': 'V1',
	'/ca/tv-show/danger-force': 'V2',
	'/ca/tv-show/1000-ways-to-die': 'V3',
	'/ca/tv-show/a-d-the-bible-continues': 'V1',
	'/ca/tv-show/campfire-cooking-in-another-world-with-my-absurd-skill': 'V2',
	'/ca/tv-show/beyond-the-gates': 'V3',
	'/ca/tv-show/creeped-out': 'V1',
	'/ca/tv-show/cathedral-of-the-sea': 'V2',
	'/ca/tv-show/chouchou': 'V3',
	'/ca/tv-show/delhi-crime': 'V1',
	'/ca/tv-show/body-of-proof': 'V2',
	'/ca/tv-show/american-manhunt-osama-bin-laden': 'V3',
	'/ca/tv-show/cowboy-bebop-2021': 'V1',
	'/ca/tv-show/clarence': 'V2',
	'/ca/tv-show/a-sign-of-affection': 'V3',
	'/ca/tv-show/dominion': 'V1',
	'/ca/tv-show/ever-after-high': 'V2',
	'/ca/tv-show/class-of-07': 'V3',
	'/ca/tv-show/black-dynamite': 'V1',
	'/ca/tv-show/blue-box': 'V2',
	'/ca/tv-show/fantasy-island': 'V3',
	'/ca/tv-show/durarara': 'V1',
	'/ca/tv-show/city-of-shadows': 'V2',
	'/ca/tv-show/alvinnn-and-the-chipmunks': 'V3',
	'/ca/tv-show/disney-twisted-wonderland-the-animation': 'V1',
	'/ca/tv-show/body-cam': 'V2',
	'/ca/tv-show/1670': 'V3',
	'/ca/tv-show/baby-daddy': 'V1',
	'/ca/tv-show/apocalypse-the-second-world-war': 'V2',
	'/ca/tv-show/echo-3': 'V3',
	'/ca/tv-show/dragons-the-nine-realms': 'V1',
	'/ca/tv-show/dragons-den-2005': 'V2',
	'/ca/tv-show/de-viaje-con-los-derbez': 'V3',
	'/ca/tv-show/dance-academy': 'V1',
	'/ca/tv-show/a-confession': 'V2',
	'/ca/tv-show/caliphate': 'V3',
	'/ca/tv-show/cassandre': 'V1',
	'/ca/tv-show/everyone-else-burns': 'V2',
	'/ca/tv-show/el-chapo': 'V3',
	'/ca/tv-show/due-south': 'V1',
	'/ca/tv-show/beyond-belief-fact-or-fiction': 'V2',
	'/ca/tv-show/fear-factor-2001': 'V3',
	'/ca/tv-show/beck': 'V1',
	'/ca/tv-show/breathless-2024': 'V2',
	'/ca/tv-show/bubble-guppies': 'V3',
	'/ca/tv-show/dirty-money': 'V1',
	'/ca/tv-show/deceitful-love': 'V2',
	'/ca/tv-show/american-experience': 'V3',
	'/ca/tv-show/dark-shadows': 'V1',
	'/ca/tv-show/codename-kids-next-door': 'V2',
	'/ca/tv-show/blade-the-series': 'V3',
	'/ca/tv-show/cracker': 'V1',
	'/ca/tv-show/big-city-greens': 'V2',
	'/ca/tv-show/devils': 'V3',
	'/ca/tv-show/defending-europe': 'V1',
	'/ca/tv-show/beast-wars-transformers': 'V2',
	'/ca/tv-show/digimon-adventure-2020': 'V3',
	'/ca/tv-show/connect-2022': 'V1',
	'/ca/tv-show/big-mood': 'V2',
	'/ca/tv-show/above-suspicion': 'V3',
	'/ca/tv-show/botched': 'V1',
	'/ca/tv-show/childrens-hospital': 'V2',
	'/ca/tv-show/bear-in-the-big-blue-house': 'V3',
	'/ca/tv-show/crossing-lines': 'V1',
	'/ca/tv-show/cosmos-possible-worlds': 'V2',
	'/ca/tv-show/barney-and-friends': 'V3',
	'/ca/tv-show/american-masters': 'V1',
	'/ca/tv-show/a-bit-of-fry-and-laurie': 'V2',
	'/ca/tv-show/atomic': 'V3',
	'/ca/tv-show/cucumber': 'V1',
	'/ca/tv-show/deep-state': 'V2',
	'/ca/tv-show/bmf': 'V3',
	'/ca/tv-show/because-this-is-my-first-life': 'V1',
	'/ca/tv-show/bad-banks': 'V2',
	'/ca/tv-show/8-out-of-10-cats': 'V3',
	'/ca/tv-show/emergency-1972': 'V1',
	'/ca/tv-show/cracked': 'V2',
	'/ca/tv-show/buried-hearts': 'V3',
	'/ca/tv-show/american-rust': 'V1',
	'/ca/tv-show/east-new-york': 'V2',
	'/ca/tv-show/citadel-diana': 'V3',
	'/ca/tv-show/americas-got-talent': 'V1',
	'/ca/tv-show/chips': 'V2',
	'/ca/tv-show/american-sports-story': 'V3',
	'/ca/tv-show/darker-than-black': 'V1',
	'/ca/tv-show/endless-love-2015': 'V2',
	'/ca/tv-show/amsterdam-empire': 'V3',
	'/ca/tv-show/escape-to-the-country': 'V1',
	'/ca/tv-show/abstract-the-art-of-design': 'V2',
	'/ca/tv-show/amphibia': 'V3',
	'/ca/tv-show/boys-over-flowers': 'V1',
	'/ca/tv-show/filthy-fortunes': 'V2',
	'/ca/tv-show/duckman': 'V3',
	'/ca/tv-show/douglas-is-cancelled': 'V1',
	'/ca/tv-show/chance': 'V2',
	'/ca/tv-show/close-enough': 'V3',
	'/ca/tv-show/crime-story': 'V1',
	'/ca/tv-show/beyblade-burst': 'V2',
	'/ca/tv-show/clark': 'V3',
	'/ca/tv-show/disneys-adventures-of-the-gummi-bears': 'V1',
	'/ca/tv-show/fame': 'V2',
	'/ca/tv-show/criminal-minds-beyond-borders': 'V3',
	'/ca/tv-show/archie': 'V1',
	'/ca/tv-show/dracula-2013': 'V2',
	'/ca/tv-show/1992': 'V3',
	'/ca/tv-show/breakout-kings': 'V1',
	'/ca/tv-show/braindead': 'V2',
	'/ca/tv-show/61st-street': 'V3',
	'/ca/tv-show/dystopia': 'V1',
	'/ca/tv-show/cagney-and-lacey': 'V2',
	'/ca/tv-show/domestic-girlfriend': 'V3',
	'/ca/tv-show/brawn-the-impossible-formula-1-story': 'V1',
	'/ca/tv-show/atlantis': 'V2',
	'/ca/tv-show/degrassi-high': 'V3',
	'/ca/tv-show/a-christmas-carol': 'V1',
	'/ca/tv-show/benidorm': 'V2',
	'/ca/tv-show/champignon-witch': 'V3',
	'/ca/tv-show/ashes-to-ashes': 'V1',
	'/ca/tv-show/bag-of-bones': 'V2',
	'/ca/tv-show/devil-in-ohio': 'V3',
	'/ca/tv-show/dinotopia-2002': 'V1',
	'/ca/tv-show/cops': 'V2',
	'/ca/tv-show/designing-women': 'V3',
	'/ca/tv-show/fate-apocrypha': 'V1',
	'/ca/tv-show/extrapolations': 'V2',
	'/ca/tv-show/american-ninja-warrior': 'V3',
	'/ca/tv-show/enlightened': 'V1',
	'/ca/tv-show/clevatess': 'V2',
	'/ca/tv-show/american-nightmare-2024': 'V3',
	'/ca/tv-show/changing-ends': 'V1',
	'/ca/tv-show/becoming-elizabeth': 'V2',
	'/ca/tv-show/families-like-ours': 'V3',
	'/ca/tv-show/cursed': 'V1',
	'/ca/tv-show/blood-and-treasure': 'V2',
	'/ca/tv-show/eerie-indiana': 'V3',
	'/ca/tv-show/curfew': 'V1',
	'/ca/tv-show/beetlejuice': 'V2',
	'/ca/tv-show/cabin-in-the-woods': 'V3',
	'/ca/tv-show/berserk-the-golden-age-arc-memorial-edition': 'V1',
	'/ca/tv-show/100-foot-wave': 'V2',
	'/ca/tv-show/a-league-of-their-own': 'V3',
	'/ca/tv-show/charitraheen': 'V1',
	'/ca/tv-show/duck-dynasty': 'V2',
	'/ca/tv-show/darby-and-joan': 'V3',
	'/ca/tv-show/black': 'V1',
	'/ca/tv-show/doctor-zhivago': 'V2',
	'/ca/tv-show/everything-sucks': 'V3',
	'/ca/tv-show/chip-n-dale-rescue-rangers': 'V1',
	'/ca/tv-show/dragon-raja': 'V2',
	'/ca/tv-show/dime-tu-nombre': 'V3',
	'/ca/tv-show/cells-at-work': 'V1',
	'/ca/tv-show/a-killer-among-friends': 'V2',
	'/ca/tv-show/angel-flight': 'V3',
	'/ca/tv-show/crashing-2017': 'V1',
	'/ca/tv-show/bad-girls-club': 'V2',
	'/ca/tv-show/casual': 'V3',
	'/ca/tv-show/bref': 'V1',
	'/ca/tv-show/film-theory': 'V2',
	'/ca/tv-show/7th-time-loop-the-villainess-enjoys-a-carefree-life-married-to-her-worst-enemy-2024': 'V3',
	'/ca/tv-show/danger-man': 'V1',
	'/ca/tv-show/eastenders': 'V2',
	'/ca/tv-show/brickleberry': 'V3',
	'/ca/tv-show/before': 'V1',
	'/ca/tv-show/dollface': 'V2',
	'/ca/tv-show/fidelity': 'V3',
	'/ca/tv-show/alice-nevers-le-juge-est-une-femme': 'V1',
	'/ca/tv-show/affinity': 'V2',
	'/ca/tv-show/fear-thy-neighbor': 'V3',
	'/ca/tv-show/class-of-09': 'V1',
	'/ca/tv-show/copper': 'V2',
	'/ca/tv-show/boarders': 'V3',
	'/ca/tv-show/bank-under-siege': 'V1',
	'/ca/tv-show/dark-city-the-cleaner': 'V2',
	'/ca/tv-show/deleting-me-chain-of-revenge': 'V3',
	'/ca/tv-show/carol-and-the-end-of-the-world': 'V1',
	'/ca/tv-show/bet': 'V2',
	'/ca/tv-show/beyond-evil': 'V3',
	'/ca/tv-show/chowder': 'V1',
	'/ca/tv-show/deadly-women': 'V2',
	'/ca/tv-show/baptiste': 'V3',
	'/ca/tv-show/a-cooks-tour': 'V1',
	'/ca/tv-show/1992-2024': 'V2',
	'/ca/tv-show/91-days': 'V3',
	'/ca/tv-show/a-plan-to-kill': 'V1',
	'/ca/tv-show/coronation-street': 'V2',
	'/ca/tv-show/arthdal-chronicles': 'V3',
	'/ca/tv-show/empress-ki': 'V1',
	'/ca/tv-show/case-histories': 'V2',
	'/ca/tv-show/dr-pimple-popper': 'V3',
	'/ca/tv-show/awkwafina-is-nora-from-queens': 'V1',
	'/ca/tv-show/chivalry-of-a-failed-knight': 'V2',
	'/ca/tv-show/fear-itself': 'V3',
	'/ca/tv-show/comedy-bang-bang': 'V1',
	'/ca/tv-show/astra-lost-in-space': 'V2',
	'/ca/tv-show/anthracite': 'V3',
	'/ca/tv-show/criminal-minds-suspect-behavior': 'V1',
	'/ca/tv-show/an-unsuitable-job-for-a-woman': 'V2',
	'/ca/tv-show/chloe': 'V3',
	'/ca/tv-show/elves-2021': 'V1',
	'/ca/tv-show/alska-mig': 'V2',
	'/ca/tv-show/chefs-table': 'V3',
	'/ca/tv-show/beyblade-metal-fusion': 'V1',
	'/ca/tv-show/ano-hi-mita-hana-no-namae-wo-bokutachi-wa-mada-shiranai': 'V2',
	'/ca/tv-show/a-body-in-the-snow-the-trial-of-karen-read': 'V3',
	'/ca/tv-show/animaniacs-2020': 'V1',
	'/ca/tv-show/alaska-daily': 'V2',
	'/ca/tv-show/charlotte': 'V3',
	'/ca/tv-show/empire-falls': 'V1',
	'/ca/tv-show/digimon-beatbreak': 'V2',
	'/ca/tv-show/crooks': 'V3',
	'/ca/tv-show/dancing-with-the-stars': 'V1',
	'/ca/tv-show/dont-come-home': 'V2',
	'/ca/tv-show/battlebots-2015': 'V3',
	'/ca/tv-show/f-troop': 'V1',
	'/ca/tv-show/celtics-city': 'V2',
	'/ca/tv-show/azumanga-daioh': 'V3',
	'/ca/tv-show/fight-night-2024': 'V1',
	'/ca/tv-show/adventures-of-superman': 'V2',
	'/ca/tv-show/come-dine-with-me': 'V3',
	'/ca/tv-show/au-service-de-la-france': 'V1',
	'/ca/tv-show/f-is-for-family': 'V2',
	'/ca/tv-show/800-words': 'V3',
	'/ca/tv-show/batwheels': 'V1',
	'/ca/tv-show/baron-noir': 'V2',
	'/ca/tv-show/duck-dynasty-the-revival': 'V3',
	'/ca/tv-show/doctor-doctor': 'V1',
	'/ca/tv-show/amy-bradley-is-missing': 'V2',
	'/ca/tv-show/alexander-the-making-of-a-god': 'V3',
	'/ca/tv-show/ancient-apocalypse': 'V1',
	'/ca/tv-show/chicago-justice': 'V2',
	'/ca/tv-show/date-a-live': 'V3',
	'/ca/tv-show/american-murder-gabby-petito': 'V1',
	'/ca/tv-show/bloodlands-2021': 'V2',
	'/ca/tv-show/alice': 'V3',
	'/ca/tv-show/car-s-o-s': 'V1',
	'/ca/tv-show/aoashi': 'V2',
	'/ca/tv-show/confidence-queen': 'V3',
	'/ca/tv-show/amagi-brilliant-park': 'V1',
	'/ca/tv-show/cheyenne': 'V2',
	'/ca/tv-show/are-you-the-one': 'V3',
	'/ca/tv-show/berserk-of-gluttony': 'V1',
	'/ca/tv-show/angela-black': 'V2',
	'/ca/tv-show/adam-ruins-everything': 'V3',
	'/ca/tv-show/david-copperfield': 'V1',
	'/ca/tv-show/a-man-in-full': 'V2',
	'/ca/tv-show/2-5-dimensional-seduction': 'V3',
	'/ca/tv-show/away': 'V1',
	'/ca/tv-show/banished': 'V2',
	'/ca/tv-show/bandidos': 'V3',
	'/ca/tv-show/7-little-johnstons': 'V1',
	'/ca/tv-show/being-erica': 'V2',
	'/ca/tv-show/earth-final-conflict': 'V3',
	'/ca/tv-show/amours-solitaires': 'V1',
	'/ca/tv-show/are-you-afraid-of-the-dark-2019': 'V2',
	'/ca/tv-show/anatomy-of-lies': 'V3',
	'/ca/tv-show/edens-zero': 'V1',
	'/ca/tv-show/eight-is-enough': 'V2',
	'/ca/tv-show/dogtanian-and-the-three-muskehounds': 'V3',
	'/ca/tv-show/cold-feet': 'V1',
	'/ca/tv-show/brotherhood': 'V2',
	'/ca/tv-show/corporate': 'V3',
	'/ca/tv-show/faraway-downs': 'V1',
	'/ca/tv-show/exploding-kittens': 'V2',
	'/ca/tv-show/cedar-cove': 'V3',
	'/ca/tv-show/crossroad-springs': 'V1',
	'/ca/tv-show/charles-in-charge': 'V2',
	'/ca/tv-show/black-butterflies': 'V3',
	'/ca/tv-show/family-business': 'V1',
	'/ca/tv-show/a-history-of-britain': 'V2',
	'/ca/tv-show/crazy-love': 'V3',
	'/ca/tv-show/90-day-fiance-uk': 'V1',
	'/ca/tv-show/elkhorn': 'V2',
	'/ca/tv-show/conviction': 'V3',
	'/ca/tv-show/clarissa-explains-it-all': 'V1',
	'/ca/tv-show/escort-boys': 'V2',
	'/ca/tv-show/a-woman-named-jackie': 'V3',
	'/ca/tv-show/care-bears-unlock-the-magic': 'V1',
	'/ca/tv-show/another-period': 'V2',
	'/ca/tv-show/chillin-in-another-world-with-level-2-super-cheat-powers': 'V3',
	'/ca/tv-show/ambulance': 'V1',
	'/ca/tv-show/dallas': 'V2',
	'/ca/tv-show/cutthroat-kitchen': 'V3',
	'/ca/tv-show/culprits': 'V1',
	'/ca/tv-show/banged-up-abroad': 'V2',
	'/ca/tv-show/cra': 'V3',
	'/ca/tv-show/aquarius': 'V1',
	'/ca/tv-show/clone-high': 'V2',
	'/ca/tv-show/burden-of-truth': 'V3',
	'/ca/tv-show/cobra-2020': 'V1',
	'/ca/tv-show/24-hours-in-police-custody': 'V2',
	'/ca/tv-show/ascendance-of-a-bookworm': 'V3',
	'/ca/tv-show/antiques-roadshow-1979': 'V1',
	'/ca/tv-show/doctor-thorne': 'V2',
	'/ca/tv-show/bitch-x-rich': 'V3',
	'/ca/tv-show/be-cool-scooby-doo': 'V1',
	'/ca/tv-show/big-nate': 'V2',
	'/ca/tv-show/dope-girls': 'V3',
	'/ca/tv-show/blue-orchestra': 'V1',
	'/ca/tv-show/back-to-life': 'V2',
	'/ca/tv-show/american-crime': 'V3',
	'/ca/tv-show/doogie-howser-m-d': 'V1',
	'/ca/tv-show/dirty-jobs': 'V2',
	'/ca/tv-show/duty-after-school': 'V3',
	'/ca/tv-show/el-silencio': 'V1',
	'/ca/tv-show/doc-mcstuffins': 'V2',
	'/ca/tv-show/balthazar': 'V3',
	'/ca/tv-show/expedition-files': 'V1',
	'/ca/tv-show/americas-test-kitchen': 'V2',
	'/ca/tv-show/between-the-world-and-us': 'V3',
	'/ca/tv-show/akudama-drive-2020': 'V1',
	'/ca/tv-show/bajo-sospecha': 'V2',
	'/ca/tv-show/bloom-into-you': 'V3',
	'/ca/tv-show/clusterf-k-woodstock-99': 'V1',
	'/ca/tv-show/fight-for-my-way': 'V2',
	'/ca/tv-show/dont-toy-with-me-miss-nagatoro': 'V3',
	'/ca/tv-show/afterlife': 'V1',
	'/ca/tv-show/entre-tierras': 'V2',
	'/ca/tv-show/as-the-crow-flies': 'V3',
	'/ca/tv-show/bad-education': 'V1',
	'/ca/tv-show/dino-dana': 'V2',
	'/ca/tv-show/bat-fam': 'V3',
	'/ca/tv-show/american-manhunt-o-j-simpson': 'V1',
	'/ca/tv-show/ballykissangel': 'V2',
	'/ca/tv-show/beckham': 'V3',
	'/ca/tv-show/churchill-at-war': 'V1',
	'/ca/tv-show/boarding-school-juliet': 'V2',
	'/ca/tv-show/aerial-america': 'V3',
	'/ca/tv-show/aaahh-real-monsters': 'V1',
	'/ca/tv-show/crushology-101': 'V2',
	'/ca/tv-show/dare-me': 'V3',
	'/ca/tv-show/equinox': 'V1',
	'/ca/tv-show/burning-love': 'V2',
	'/ca/tv-show/fiertes': 'V3',
	'/ca/tv-show/capture': 'V1',
	'/ca/tv-show/choose-earth': 'V2',
	'/ca/tv-show/between-two-ferns-with-zach-galifianakis': 'V3',
	'/ca/tv-show/akashic-records-of-bastard-magic-instructor': 'V1',
	'/ca/tv-show/after-the-rain': 'V2',
	'/ca/tv-show/canadas-drag-race': 'V3',
	'/ca/tv-show/ex-on-the-beach': 'V1',
	'/ca/tv-show/caillou': 'V2',
	'/ca/tv-show/doom-at-your-service-2021': 'V3',
	'/ca/tv-show/degrassi-next-class': 'V1',
	'/ca/tv-show/ancient-aliens-origins': 'V2',
	'/ca/tv-show/beowulf-return-to-the-shieldlands': 'V3',
	'/ca/tv-show/containment': 'V1',
	'/ca/tv-show/diffrent-strokes': 'V2',
	'/ca/tv-show/as-time-goes-by': 'V3',
	'/ca/tv-show/cult-massacre-one-day-in-jonestown': 'V1',
	'/ca/tv-show/coffee-prince-2007': 'V2',
	'/ca/tv-show/cleddau': 'V3',
	'/ca/tv-show/climax-2026': 'V1',
	'/ca/tv-show/dimension-404': 'V2',
	'/ca/tv-show/fatal-attraction-2013': 'V3',
	'/ca/tv-show/digimon-tamers': 'V1',
	'/ca/tv-show/bupkis': 'V2',
	'/ca/tv-show/arnold': 'V3',
	'/ca/tv-show/ajin': 'V1',
	'/ca/tv-show/american-gigolo': 'V2',
	'/ca/tv-show/dangerous-liaisons': 'V3',
	'/ca/tv-show/conversations-with-a-killer-the-john-wayne-gacy-tapes': 'V1',
	'/ca/tv-show/clerks-the-animated-series': 'V2',
	'/ca/tv-show/billy-and-dom-eat-the-world': 'V3',
	'/ca/tv-show/exchange': 'V1',
	'/ca/tv-show/arknights': 'V2',
	'/ca/tv-show/diary-of-a-ditched-girl': 'V3',
	'/ca/tv-show/dragnet': 'V1',
	'/ca/tv-show/being-mary-jane': 'V2',
	'/ca/tv-show/blindspotting': 'V3',
	'/ca/tv-show/around-the-world-with-willy-fog': 'V1',
	'/ca/tv-show/dallas-cowboys-cheerleaders-making-the-team': 'V2',
	'/ca/tv-show/europe-from-above': 'V3',
	'/ca/tv-show/citadel-honey-bunny': 'V1',
	'/ca/tv-show/conquering-northern-china': 'V2',
	'/ca/tv-show/anyway-im-falling-in-love-with-you': 'V3',
	'/ca/tv-show/better-call-saul-los-pollos-hermanos-employee-training': 'V1',
	'/ca/tv-show/dargent-et-de-sang': 'V2',
	'/ca/tv-show/country-music': 'V3',
	'/ca/tv-show/battle-of-the-planets': 'V1',
	'/ca/tv-show/bad-and-crazy': 'V2',
	'/ca/tv-show/faking-it-2014': 'V3',
	'/ca/tv-show/el-cid': 'V1',
	'/ca/tv-show/blood-2018': 'V2',
	'/ca/tv-show/antiques-road-trip': 'V3',
	'/ca/tv-show/dr-phil': 'V1',
	'/ca/tv-show/dickensian': 'V2',
	'/ca/tv-show/blippi': 'V3',
	'/ca/tv-show/call-it-love': 'V1',
	'/ca/tv-show/american-crime-story-the-assassination-of-gianni-versace': 'V2',
	'/ca/tv-show/alexa-and-katie': 'V3',
	'/ca/tv-show/amanda-and-alans-spanish-job': 'V1',
	'/ca/tv-show/beyond': 'V2',
	'/ca/tv-show/conan-the-adventurer-1997': 'V3',
	'/ca/tv-show/brian-jacques-redwall': 'V1',
	'/ca/tv-show/american-auto': 'V2',
	'/ca/tv-show/doctor-slump': 'V3',
	'/ca/tv-show/el-dia-menos-pensado': 'V1',
	'/ca/tv-show/control-z': 'V2',
	'/ca/tv-show/danny-will-die-alone': 'V3',
	'/ca/tv-show/cold-case-files-2017': 'V1',
	'/ca/tv-show/dead-dead-demons-dededede-destruction': 'V2',
	'/ca/tv-show/blue-ridge': 'V3',
	'/ca/tv-show/breaking-in': 'V1',
	'/ca/tv-show/dynasties': 'V2',
	'/ca/tv-show/anna-2022': 'V3',
	'/ca/tv-show/a-gatherers-adventure-in-isekai': 'V1',
	'/ca/tv-show/dudes-2025': 'V2',
	'/ca/tv-show/back': 'V3',
	'/ca/tv-show/digging-for-britain': 'V1',
	'/ca/tv-show/disasters-at-sea': 'V2',
	'/ca/tv-show/back-at-the-barnyard': 'V3',
	'/ca/tv-show/24-legacy': 'V1',
	'/ca/tv-show/american-born-chinese': 'V2',
	'/ca/tv-show/cometierra': 'V3',
	'/ca/tv-show/buried-in-the-backyard': 'V1',
	'/ca/tv-show/burn-the-witch': 'V2',
	'/ca/tv-show/beastmaster': 'V3',
	'/ca/tv-show/dream-productions': 'V1',
	'/ca/tv-show/como-cazar-a-un-monstruo': 'V2',
	'/ca/tv-show/black-narcissus': 'V3',
	'/ca/tv-show/austin-and-ally': 'V1',
	'/ca/tv-show/a-crime-to-remember': 'V2',
	'/ca/tv-show/baby-looney-tunes': 'V3',
	'/ca/tv-show/babar': 'V1',
	'/ca/tv-show/again-my-life': 'V2',
	'/ca/tv-show/catching-killers': 'V3',
	'/ca/tv-show/chiikawa': 'V1',
	'/ca/tv-show/dora-the-explorer-2024': 'V2',
	'/ca/tv-show/drain-the-ocean': 'V3',
	'/ca/tv-show/born-to-be-wild-2025': 'V1',
	'/ca/tv-show/death-note-2015': 'V2',
	'/ca/tv-show/daily-dose-of-sunshine': 'V3',
	'/ca/tv-show/contraband-seized-at-the-border': 'V1',
	'/ca/tv-show/dias-mejores': 'V2',
	'/ca/tv-show/explained': 'V3',
	'/ca/tv-show/find-me-in-your-memory': 'V1',
	'/ca/tv-show/aussie-gold-hunters': 'V2',
	'/ca/tv-show/erased': 'V3',
	'/ca/tv-show/blade-of-the-immortal-2019': 'V1',
	'/ca/tv-show/a-returners-magic-should-be-special': 'V2',
	'/ca/tv-show/bebes-llorones-lagrimas-magicas': 'V3',
	'/ca/tv-show/doctor-stranger': 'V1',
	'/ca/tv-show/1971-the-year-that-music-changed-everything': 'V2',
	'/ca/tv-show/dead-of-summer': 'V3',
	'/ca/tv-show/behzat-c-bir-ankara-polisiyesi': 'V1',
	'/ca/tv-show/call-my-agent-berlin': 'V2',
	'/ca/tv-show/beast-machines': 'V3',
	'/ca/tv-show/dna-nl': 'V1',
	'/ca/tv-show/cherry-magic-thirty-years-of-virginity-can-make-you-a-wizard': 'V2',
	'/ca/tv-show/droners': 'V3',
	'/ca/tv-show/deca-dence': 'V1',
	'/ca/tv-show/americas-sweethearts-dallas-cowboys-cheerleaders': 'V2',
	'/ca/tv-show/dead-pixels': 'V3',
	'/ca/tv-show/beast-tamer': 'V1',
	'/ca/tv-show/destination-x': 'V2',
	'/ca/tv-show/ekaterina': 'V3',
	'/ca/tv-show/comedians-in-cars-getting-coffee': 'V1',
	'/ca/tv-show/bofuri-i-dont-want-to-get-hurt-so-ill-max-out-my-defense': 'V2',
	'/ca/tv-show/black-jesus': 'V3',
	'/ca/tv-show/cybill': 'V1',
	'/ca/tv-show/charlie-and-lola': 'V2',
	'/ca/tv-show/breaking-amish': 'V3',
	'/ca/tv-show/brave-and-beautiful': 'V1',
	'/ca/tv-show/dinosaur-king': 'V2',
	'/ca/tv-show/accused-did-i-do-it': 'V3',
	'/ca/tv-show/catch-me-a-killer': 'V1',
	'/ca/tv-show/about-face-2025': 'V2',
	'/ca/tv-show/amnesia-2004': 'V3',
	'/ca/tv-show/cobra': 'V1',
	'/ca/tv-show/a-very-royal-crisis-countdown-to-abdication': 'V2',
	'/ca/tv-show/are-you-sure': 'V3',
	'/ca/tv-show/d-gray-man': 'V1',
	'/ca/tv-show/are-you-safe': 'V2',
	'/ca/tv-show/bh90210': 'V3',
	'/ca/tv-show/destined-with-you': 'V1',
	'/ca/tv-show/actress': 'V2',
	'/ca/tv-show/ark-the-animated-series': 'V3',
	'/ca/tv-show/deputy': 'V1',
	'/ca/tv-show/bride-killa': 'V2',
	'/ca/tv-show/a-killer-paradox': 'V3',
	'/ca/tv-show/birdsong': 'V1',
	'/ca/tv-show/dogs-of-berlin': 'V2',
	'/ca/tv-show/andi-mack': 'V3',
	'/ca/tv-show/adam-12': 'V1',
	'/ca/tv-show/fast-and-furious-spy-racers': 'V2',
	'/ca/tv-show/brain-games': 'V3',
	'/ca/tv-show/angels-of-death': 'V1',
	'/ca/tv-show/class-of-lies': 'V2',
	'/ca/tv-show/a-dream-within-a-dream': 'V3',
	'/ca/tv-show/departures': 'V1',
	'/ca/tv-show/betty-la-fea-the-story-continues': 'V2',
	'/ca/tv-show/an-incurable-case-of-love': 'V3',
	'/ca/tv-show/bunkd': 'V1',
	'/ca/tv-show/dear-hongrang': 'V2',
	'/ca/tv-show/celebrity': 'V3',
	'/ca/tv-show/before-we-die-2021': 'V1',
	'/ca/tv-show/borats-american-lockdown-and-debunking-borat': 'V2',
	'/ca/tv-show/allen-v-farrow': 'V3',
	'/ca/tv-show/club-de-cuervos': 'V1',
	'/ca/tv-show/cheer-up-2022': 'V2',
	'/ca/tv-show/capitaine-marleau': 'V3',
	'/ca/tv-show/alaska-state-troopers': 'V1',
	'/ca/tv-show/baroness-von-sketch-show': 'V2',
	'/ca/tv-show/dr-pimple-popper-breaking-out': 'V3',
	'/ca/tv-show/auschwitz-the-nazis-and-the-final-solution': 'V1',
	'/ca/tv-show/embarrassing-bodies': 'V2',
	'/ca/tv-show/bands-of-enchantment': 'V3',
	'/ca/tv-show/danger-mouse': 'V1',
	'/ca/tv-show/american-manhunt-the-boston-marathon-bombing': 'V2',
	'/ca/tv-show/berlin-berlin': 'V3',
	'/ca/tv-show/accident-suicide-or-murder': 'V1',
	'/ca/tv-show/borgen-power-and-glory-2022': 'V2',
	'/ca/tv-show/aesthetica-of-a-rogue-hero': 'V3',
	'/ca/tv-show/dakaichi-im-being-harassed-by-the-sexiest-man-of-the-year': 'V1',
	'/ca/tv-show/buba': 'V2',
	'/ca/tv-show/angry-boys': 'V3',
	'/ca/tv-show/dealing-with-mikadono-sisters-is-a-breeze': 'V1',
	'/ca/tv-show/best-interests': 'V2',
	'/ca/tv-show/baby-einstein-classics': 'V3',
	'/ca/tv-show/beck-mongolian-chop-squad': 'V1',
	'/ca/tv-show/demain-nous-appartient': 'V2',
	'/ca/tv-show/farmer-wants-a-wife': 'V3',
	'/ca/tv-show/american-conspiracy-the-octopus-murders': 'V1',
	'/ca/tv-show/crime-scene-the-vanishing-at-the-cecil-hotel': 'V2',
	'/ca/tv-show/conversations-with-a-killer-the-jeffrey-dahmer-tapes': 'V3',
	'/ca/tv-show/conviction-2006': 'V1',
	'/ca/tv-show/bloodride': 'V2',
	'/ca/tv-show/blue-murder': 'V3',
	'/ca/tv-show/behind-your-touch': 'V1',
	'/ca/tv-show/citrus': 'V2',
	'/ca/tv-show/car-masters-rust-to-riches': 'V3',
	'/ca/tv-show/bajillion-dollar-propertie': 'V1',
	'/ca/tv-show/bob-and-margaret': 'V2',
	'/ca/tv-show/bad-influence-the-dark-side-of-kidfluencing': 'V3',
	'/ca/tv-show/dear-my-friends': 'V1',
	'/ca/tv-show/days-with-my-step-sister': 'V2',
	'/ca/tv-show/cherif': 'V3',
	'/ca/tv-show/anna': 'V1',
	'/ca/tv-show/beyond-the-dark': 'V2',
	'/ca/tv-show/behind-the-attraction': 'V3',
	'/ca/tv-show/apocalypse-la-premiere-guerre-mondiale': 'V1',
	'/ca/tv-show/engage-kiss': 'V2',
	'/ca/tv-show/eyes-on-the-prize-iii-we-who-believe-in-freedom-cannot-rest': 'V3',
	'/ca/tv-show/central-park': 'V1',
	'/ca/tv-show/eureka-seven': 'V2',
	'/ca/tv-show/elena-of-avalor': 'V3',
	'/ca/tv-show/a-private-affair': 'V1',
	'/ca/tv-show/breadwinners': 'V2',
	'/ca/tv-show/chez-maupassant': 'V3',
	'/ca/tv-show/betrayal': 'V1',
	'/ca/tv-show/dirty-sexy-money': 'V2',
	'/ca/tv-show/entrapped-2022': 'V3',
	'/ca/tv-show/estonia-a-find-that-changes-everything': 'V1',
	'/ca/tv-show/face-a-face': 'V2',
	'/ca/tv-show/burnistoun': 'V3',
	'/ca/tv-show/di4ri': 'V1',
	'/ca/tv-show/destruction-decoded': 'V2',
	'/ca/tv-show/curon': 'V3',
	'/ca/tv-show/crisis-in-six-scenes': 'V1',
	'/ca/tv-show/carole-and-tuesday': 'V2',
	'/ca/tv-show/2019': 'V3',
	'/ca/tv-show/digimon-adventure-tri': 'V1',
	'/ca/tv-show/bakugan-battle-planet': 'V2',
	'/ca/tv-show/feds': 'V3',
	'/ca/tv-show/adventures-of-sonic-the-hedgehog': 'V1',
	'/ca/tv-show/are-you-human': 'V2',
	'/ca/tv-show/bee-and-puppycat': 'V3',
	'/ca/tv-show/everythings-gonna-be-okay': 'V1',
	'/ca/tv-show/defenders-of-the-earth': 'V2',
	'/ca/tv-show/alaska-the-last-frontier': 'V3',
	'/ca/tv-show/celebrity-deathmatch': 'V1',
	'/ca/tv-show/all-american-homecoming': 'V2',
	'/ca/tv-show/clone-high-2023': 'V3',
	'/ca/tv-show/black-money-love': 'V1',
	'/ca/tv-show/deadbeat': 'V2',
	'/ca/tv-show/denver-the-last-dinosaur': 'V3',
	'/ca/tv-show/desert-law': 'V1',
	'/ca/tv-show/fantastic-friends': 'V2',
	'/ca/tv-show/fastlane': 'V3',
	'/ca/tv-show/angel-cop': 'V1',
	'/ca/tv-show/an-archdemons-dilemma-how-to-love-your-elf-bride': 'V2',
	'/ca/tv-show/akiba-maid-war': 'V3',
	'/ca/tv-show/capturing-their-killer-the-girls-on-the-high-bridge': 'V1',
	'/ca/tv-show/cake-boss': 'V2',
	'/ca/tv-show/eyeshield-21': 'V3',
	'/ca/tv-show/blood-ties': 'V1',
	'/ca/tv-show/banished-from-the-heros-party-i-decided-to-live-a-quiet-life-in-the-countryside': 'V2',
	'/ca/tv-show/delocated': 'V3',
	'/ca/tv-show/beauty-and-the-billionaire': 'V1',
	'/ca/tv-show/betty': 'V2',
	'/ca/tv-show/code-geass-roze-of-the-recapture': 'V3',
	'/ca/tv-show/baymax': 'V1',
	'/ca/tv-show/deadliest-warrior': 'V2',
	'/ca/tv-show/bobbys-world': 'V3',
	'/ca/tv-show/bobobo-bo-bo-bobo': 'V1',
	'/ca/tv-show/black-adder-ii': 'V2',
	'/ca/tv-show/bad-guys': 'V3',
	'/ca/tv-show/earth-to-luna': 'V1',
	'/ca/tv-show/accused-guilty-or-innocent': 'V2',
	'/ca/tv-show/fated-to-love-you-2014': 'V3',
	'/ca/tv-show/baby-bandito': 'V1',
	'/ca/tv-show/codename-annika': 'V2',
	'/ca/tv-show/college-romance': 'V3',
	'/ca/tv-show/bring-it-on-ghost': 'V1',
	'/ca/tv-show/fanboy-and-chum-chum': 'V2',
	'/ca/tv-show/damnation': 'V3',
	'/ca/tv-show/american-gladiators': 'V1',
	'/ca/tv-show/11-minutes': 'V2',
	'/ca/tv-show/darknet': 'V3',
	'/ca/tv-show/dark-angel': 'V1',
	'/ca/tv-show/cold-justice': 'V2',
	'/ca/tv-show/acquitted': 'V3',
	'/ca/tv-show/extreme-ghostbusters': 'V1',
	'/ca/tv-show/a-n-t-farm': 'V2',
	'/ca/tv-show/attack-on-london-hunting-the-7-7-bombers': 'V3',
	'/ca/tv-show/ambulance-australia': 'V1',
	'/ca/tv-show/a-good-day-to-be-a-dog': 'V2',
	'/ca/tv-show/fantasy-island-2021': 'V3',
	'/ca/tv-show/chobits': 'V1',
	'/ca/tv-show/bridezillas': 'V2',
	'/ca/tv-show/ferry-the-series': 'V3',
	'/ca/tv-show/bonnie-and-clyde': 'V1',
	'/ca/tv-show/1983': 'V2',
	'/ca/tv-show/darwins-game': 'V3',
	'/ca/tv-show/drunken-romance': 'V1',
	'/ca/tv-show/blinded': 'V2',
	'/ca/tv-show/bulletproof': 'V3',
	'/ca/tv-show/chefs-table-pizza': 'V1',
	'/ca/tv-show/dark-side-of-the-90s': 'V2',
	'/ca/tv-show/believe': 'V3',
	'/ca/tv-show/barefoot-contessa': 'V1',
	'/ca/tv-show/eastsiders': 'V2',
	'/ca/tv-show/drag-race-espana': 'V3',
	'/ca/tv-show/faerie-tale-theatre': 'V1',
	'/ca/tv-show/akebis-sailor-uniform': 'V2',
	'/ca/tv-show/bad-buddy': 'V3',
	'/ca/tv-show/bigfoot-took-her': 'V1',
	'/ca/tv-show/eli-stone': 'V2',
	'/ca/tv-show/expedition-bigfoot': 'V3',
	'/ca/tv-show/acorralada': 'V1',
	'/ca/tv-show/educators': 'V2',
	'/ca/tv-show/betrothed-to-my-sisters-ex': 'V3',
	'/ca/tv-show/cocomelon': 'V1',
	'/ca/tv-show/difficult-people': 'V2',
	'/ca/tv-show/crash': 'V3',
	'/ca/tv-show/d-p': 'V1',
	'/ca/tv-show/challenger-the-final-flight': 'V2',
	'/ca/tv-show/evil-lives-here-shadows-of-death': 'V3',
	'/ca/tv-show/conversations-with-a-killer-the-son-of-sam-tapes': 'V1',
	'/ca/tv-show/death-march-to-the-parallel-world-rhapsody': 'V2',
	'/ca/tv-show/black-summoner': 'V3',
	'/ca/tv-show/animals': 'V1',
	'/ca/tv-show/around-the-world-in-80-days': 'V2',
	'/ca/tv-show/celebrity-family-feud': 'V3',
	'/ca/tv-show/conan': 'V1',
	'/ca/tv-show/a-d-police-files': 'V2',
	'/ca/tv-show/6teen': 'V3',
	'/ca/tv-show/emperor-of-ocean-park': 'V1',
	'/ca/tv-show/cursed-films-2020': 'V2',
	'/ca/tv-show/dead-mans-walk': 'V3',
	'/ca/tv-show/emergence': 'V1',
	'/ca/tv-show/customer-wars': 'V2',
	'/ca/tv-show/delicious': 'V3',
	'/ca/tv-show/captain-fall': 'V1',
	'/ca/tv-show/dead-mount-death-play': 'V2',
	'/ca/tv-show/astro-boy-1980': 'V3',
	'/ca/tv-show/dancing-for-the-devil-the-7m-tiktok-cult': 'V1',
	'/ca/tv-show/creature': 'V2',
	'/ca/tv-show/family-affair': 'V3',
	'/ca/tv-show/agent-elvis': 'V1',
	'/ca/tv-show/chuggington': 'V2',
	'/ca/tv-show/42-days-in-the-dark': 'V3',
	'/ca/tv-show/big-timber': 'V1',
	'/ca/tv-show/another-miss-oh': 'V2',
	'/ca/tv-show/black-box': 'V3',
	'/ca/tv-show/bugs-bunny-builders': 'V1',
	'/ca/tv-show/bondi-vet': 'V2',
	'/ca/tv-show/escaping-utopia': 'V3',
	'/ca/tv-show/a-korean-odyssey': 'V1',
	'/ca/tv-show/be-my-boyfriend': 'V2',
	'/ca/tv-show/chihayafuru': 'V3',
	'/ca/tv-show/99': 'V1',
	'/ca/tv-show/dear-mama': 'V2',
	'/ca/tv-show/dino-ranch': 'V3',
	'/ca/tv-show/escaping-twin-flames': 'V1',
	'/ca/tv-show/crematorio': 'V2',
	'/ca/tv-show/below-deck-adventure': 'V3',
	'/ca/tv-show/a-real-bugs-life': 'V1',
	'/ca/tv-show/dokgo-rewind': 'V2',
	'/ca/tv-show/dr-cha-jung-sook': 'V3',
	'/ca/tv-show/as-a-reincarnated-aristocrat-ill-use-my-appraisal-skill-to-rise-in-the-world-2024': 'V1',
	'/ca/tv-show/ctrl-alt-desire': 'V2',
	'/ca/tv-show/danganronpa-3-the-end-of-hopes-peak-high-school': 'V3',
	'/ca/tv-show/cleopatra': 'V1',
	'/ca/tv-show/bananas-in-pyjamas-1992': 'V2',
	'/ca/tv-show/24-india': 'V3',
	'/ca/tv-show/cloudy-with-a-chance-of-meatballs': 'V1',
	'/ca/tv-show/an-update-on-our-family': 'V2',
	'/ca/tv-show/antiques-roadshow': 'V3',
	'/ca/tv-show/even-stevens': 'V1',
	'/ca/tv-show/america-unearthed': 'V2',
	'/ca/tv-show/dirty-pop-the-boy-band-scam': 'V3',
	'/ca/tv-show/chosen': 'V1',
	'/ca/tv-show/burden-of-guilt': 'V2',
	'/ca/tv-show/chewin-the-fat': 'V3',
	'/ca/tv-show/age-of-samurai-battle-for-japan': 'V1',
	'/ca/tv-show/dalziel-and-pascoe': 'V2',
	'/ca/tv-show/american-playboy-the-hugh-hefner-story': 'V3',
	'/ca/tv-show/all-access-pd-grand-rapids': 'V1',
	'/ca/tv-show/connections-with-james-burke': 'V2',
	'/ca/tv-show/elizabeth-r': 'V3',
	'/ca/tv-show/atlantic-crossing': 'V1',
	'/ca/tv-show/car-54-where-are-you': 'V2',
	'/ca/tv-show/fiasco-2024': 'V3',
	'/ca/tv-show/bravest-warriors': 'V1',
	'/ca/tv-show/cocaine-cowboys-the-kings-of-miami': 'V2',
	'/ca/tv-show/dancing-on-the-edge': 'V3',
	'/ca/tv-show/1864': 'V1',
	'/ca/tv-show/ben-to': 'V2',
	'/ca/tv-show/fatma': 'V3',
	'/ca/tv-show/beautiful-people-2008': 'V1',
	'/ca/tv-show/ace-ventura-pet-detective-the-series': 'V2',
	'/ca/tv-show/family-the-unbreakable-bond': 'V3',
	'/ca/tv-show/bomb-girls': 'V1',
	'/ca/tv-show/answer-me-1994': 'V2',
	'/ca/tv-show/discovering-film': 'V3',
	'/ca/tv-show/crossfire': 'V1',
	'/ca/tv-show/die-fraggles-back-to-the-rock': 'V2',
	'/ca/tv-show/disjointed': 'V3',
	'/ca/tv-show/blood-free': 'V1',
	'/ca/tv-show/backstrom': 'V2',
	'/ca/tv-show/daily-lives-of-high-school-boys': 'V3',
	'/ca/tv-show/a-girl-and-her-guard-dog': 'V1',
	'/ca/tv-show/bernard': 'V2',
	'/ca/tv-show/dr-jeff-rocky-mountain-vet': 'V3',
	'/ca/tv-show/chicago-typewriter': 'V1',
	'/ca/tv-show/bodies': 'V2',
	'/ca/tv-show/bella-and-the-bulldogs': 'V3',
	'/ca/tv-show/abyss': 'V1',
	'/ca/tv-show/a-kind-of-spark': 'V2',
	'/ca/tv-show/airline-wars': 'V3',
	'/ca/tv-show/daniel-sloss-live-shows': 'V1',
	'/ca/tv-show/angry-birds-toons': 'V2',
	'/ca/tv-show/abandoned-the-woman-in-the-decaying-house': 'V3',
	'/ca/tv-show/aurora-teagarden-mysteries': 'V1',
	'/ca/tv-show/dramaworld': 'V2',
	'/ca/tv-show/beat': 'V3',
	'/ca/tv-show/bering-sea-gold': 'V1',
	'/ca/tv-show/fbi-true': 'V2',
	'/ca/tv-show/abby-hatcher': 'V3',
	'/ca/tv-show/bloodline-detectives': 'V1',
	'/ca/tv-show/by-the-grace-of-the-gods': 'V2',
	'/ca/tv-show/everything-is-fine': 'V3',
	'/ca/tv-show/better-man-2016': 'V1',
	'/ca/tv-show/dreamworks-how-to-train-your-dragon-legends': 'V2',
	'/ca/tv-show/blown-away': 'V3',
	'/ca/tv-show/all-saints': 'V1',
	'/ca/tv-show/dan-vs': 'V2',
	'/ca/tv-show/breathe': 'V3',
	'/ca/tv-show/broken-2017': 'V1',
	'/ca/tv-show/dennis-miller-live': 'V2',
	'/ca/tv-show/baby-sharks-big-show': 'V3',
	'/ca/tv-show/a-very-brady-renovation': 'V1',
	'/ca/tv-show/dateline-secrets-uncovered': 'V2',
	'/ca/tv-show/camping': 'V3',
	'/ca/tv-show/a-bloody-lucky-day': 'V1',
	'/ca/tv-show/dal-ri-and-gamjatang': 'V2',
	'/ca/tv-show/100-years-of-warner-bros': 'V3',
	'/ca/tv-show/femme-fatales': 'V1',
	'/ca/tv-show/crime-scene-the-texas-killing-fields': 'V2',
	'/ca/tv-show/dna2': 'V3',
	'/ca/tv-show/copycat-killer': 'V1',
	'/ca/tv-show/amor-animal': 'V2',
	'/ca/tv-show/dennis-the-menace': 'V3',
	'/ca/tv-show/casanova': 'V1',
	'/ca/tv-show/code-of-a-killer': 'V2',
	'/ca/tv-show/andhera': 'V3',
	'/ca/tv-show/3below-tales-of-arcadia': 'V1',
	'/ca/tv-show/call-her-alex': 'V2',
	'/ca/tv-show/age-of-youth': 'V3',
	'/ca/tv-show/back-to-the-frontier': 'V1',
	'/ca/tv-show/electric-bloom': 'V2',
	'/ca/tv-show/american-detective-with-lt-joe-kenda': 'V3',
	'/ca/tv-show/derailment': 'V1',
	'/ca/tv-show/16-and-pregnant': 'V2',
	'/ca/tv-show/china-il': 'V3',
	'/ca/tv-show/bts-monuments-beyond-the-star': 'V1',
	'/ca/tv-show/earth': 'V2',
	'/ca/tv-show/branding-in-seongsu': 'V3',
	'/ca/tv-show/body-bizarre': 'V1',
	'/ca/tv-show/fboy-island': 'V2',
	'/ca/tv-show/ethos': 'V3',
	'/ca/tv-show/eagleheart': 'V1',
	'/ca/tv-show/cowboy-cartel': 'V2',
	'/ca/tv-show/fifteen-love': 'V3',
	'/ca/tv-show/blandings': 'V1',
	'/ca/tv-show/dietland': 'V2',
	'/ca/tv-show/destination-truth': 'V3',
	'/ca/tv-show/endangered-planet': 'V1',
	'/ca/tv-show/44-gatti': 'V2',
	'/ca/tv-show/black-work': 'V3',
	'/ca/tv-show/allen-iv3rson': 'V1',
	'/ca/tv-show/altes-geld': 'V2',
	'/ca/tv-show/chasing-the-west': 'V3',
	'/ca/tv-show/attenboroughs-life-in-colour': 'V1',
	'/ca/tv-show/angels-last-mission-love': 'V2',
	'/ca/tv-show/a-body-that-works': 'V3',
	'/ca/tv-show/cry-wolf': 'V1',
	'/ca/tv-show/battle-kitty': 'V2',
	'/ca/tv-show/charlieand-39-s-angels': 'V3',
	'/ca/tv-show/ackley-bridge': 'V1',
	'/ca/tv-show/absolute-beginners': 'V2',
	'/ca/tv-show/born-again': 'V3',
	'/ca/tv-show/deadmans-curse': 'V1',
	'/ca/tv-show/cyberchase': 'V2',
	'/ca/tv-show/america-the-story-of-us': 'V3',
	'/ca/tv-show/digimon-fusion': 'V1',
	'/ca/tv-show/dragons-rescue-riders': 'V2',
	'/ca/tv-show/dhootha': 'V3',
	'/ca/tv-show/big-girls-dont-cry-bgdc': 'V1',
	'/ca/tv-show/excel-saga': 'V2',
	'/ca/tv-show/callan': 'V3',
	'/ca/tv-show/attack-on-titan-junior-high': 'V1',
	'/ca/tv-show/captain-scarlet-and-the-mysterons': 'V2',
	'/ca/tv-show/close-to-home-murder-in-the-coalfield': 'V3',
	'/ca/tv-show/emily-owens-m-d': 'V1',
	'/ca/tv-show/death-and-nightingales': 'V2',
	'/ca/tv-show/action-figure-adventure': 'V3',
	'/ca/tv-show/dinner-club': 'V1',
	'/ca/tv-show/clique': 'V2',
	'/ca/tv-show/alphonse': 'V3',
	'/ca/tv-show/cold-case-who-killed-jonbenet-ramsey': 'V1',
	'/ca/tv-show/delirium': 'V2',
	'/ca/tv-show/blonde': 'V3',
	'/ca/tv-show/babar-and-the-adventures-of-badou': 'V1',
	'/ca/tv-show/booked-first-day-in': 'V2',
	'/ca/tv-show/drew-careys-improv-a-ganza': 'V3',
	'/ca/tv-show/born-to-kill-2005': 'V1',
	'/ca/tv-show/227': 'V2',
	'/ca/tv-show/belfort-and-lupin': 'V3',
	'/ca/tv-show/eden': 'V1',
	'/ca/tv-show/fast-n-loud': 'V2',
	'/ca/tv-show/deal-or-no-deal': 'V3',
	'/ca/tv-show/dinotopia': 'V1',
	'/ca/tv-show/agatha-christies-partners-in-crime': 'V2',
	'/ca/tv-show/eleventh-hour-2008': 'V3',
	'/ca/tv-show/criminal-justice': 'V1',
	'/ca/tv-show/ahiru-no-sora': 'V2',
	'/ca/tv-show/dr-death-the-undoctored-story': 'V3',
	'/ca/tv-show/do-you-love-your-mom-and-her-two-hit-multi-target-attacks': 'V1',
	'/ca/tv-show/cheaters': 'V2',
	'/ca/tv-show/el-dragon': 'V3',
	'/ca/tv-show/101-dalmatians-the-series': 'V1',
	'/ca/tv-show/about-a-boy': 'V2',
	'/ca/tv-show/ai-football-ggo': 'V3',
	'/ca/tv-show/fillmore': 'V1',
	'/ca/tv-show/booker': 'V2',
	'/ca/tv-show/all-my-children': 'V3',
	'/ca/tv-show/a-tale-dark-and-grimm': 'V1',
	'/ca/tv-show/dicte': 'V2',
	'/ca/tv-show/chios-school-road': 'V3',
	'/ca/tv-show/camp-lakebottom': 'V1',
	'/ca/tv-show/boyhood': 'V2',
	'/ca/tv-show/doubt-2024': 'V3',
	'/ca/tv-show/a-perfect-planet': 'V1',
	'/ca/tv-show/famalam': 'V2',
	'/ca/tv-show/butterbeans-cafe': 'V3',
	'/ca/tv-show/eleventh-hour': 'V1',
	'/ca/tv-show/fate-extra-last-encore': 'V2',
	'/ca/tv-show/a-to-z': 'V3',
	'/ca/tv-show/2gether-the-series': 'V1',
	'/ca/tv-show/aldnoah-zero': 'V2',
	'/ca/tv-show/caught-in-the-act-double-life': 'V3',
	'/ca/tv-show/damien': 'V1',
	'/ca/tv-show/c-o-p-s': 'V2',
	'/ca/tv-show/defying-gravity': 'V3',
	'/ca/tv-show/braceface': 'V1',
	'/ca/tv-show/creature-comforts': 'V2',
	'/ca/tv-show/crimes-that-shook-australia': 'V3',
	'/ca/tv-show/alex-and-co': 'V1',
	'/ca/tv-show/becoming-frida-kahlo': 'V2',
	'/ca/tv-show/aj-and-the-queen': 'V3',
	'/ca/tv-show/el-chema': 'V1',
	'/ca/tv-show/bubblegum-crash': 'V2',
	'/ca/tv-show/clean-slate': 'V3',
	'/ca/tv-show/boon': 'V1',
	'/ca/tv-show/castle-impossible': 'V2',
	'/ca/tv-show/alone-frozen': 'V3',
	'/ca/tv-show/divorce-lawyer': 'V1',
	'/ca/tv-show/fanta-g-spot': 'V2',
	'/ca/tv-show/double-dragon': 'V3',
	'/ca/tv-show/apache-the-life-of-carlos-tevez': 'V1',
	'/ca/tv-show/confess': 'V2',
	'/ca/tv-show/captain-n-the-game-master': 'V3',
	'/ca/tv-show/aria-the-animation': 'V1',
	'/ca/tv-show/crikey-its-the-irwins': 'V2',
	'/ca/tv-show/1994': 'V3',
	'/ca/tv-show/building-off-the-grid': 'V1',
	'/ca/tv-show/astro-boy-1963': 'V2',
	'/ca/tv-show/before-we-die': 'V3',
	'/ca/tv-show/connected': 'V1',
	'/ca/tv-show/fate-strange-fake-whispers-of-dawn': 'V2',
	'/ca/tv-show/are-you-smarter-than-a-5th-grader-2007': 'V3',
	'/ca/tv-show/cupids-kitchen': 'V1',
	'/ca/tv-show/bang-bang-baby': 'V2',
	'/ca/tv-show/dong-yi': 'V3',
	'/ca/tv-show/famous-in-love': 'V1',
	'/ca/tv-show/death-in-holy-orders': 'V2',
	'/ca/tv-show/bardot': 'V3',
	'/ca/tv-show/detroit-metal-city': 'V1',
	'/ca/tv-show/cocaine-air-smugglers-at-30-000-ft': 'V2',
	'/ca/tv-show/amityville-an-origin-story': 'V3',
	'/ca/tv-show/a-love-so-beautiful': 'V1',
	'/ca/tv-show/a-girl-and-an-astronaut': 'V2',
	'/ca/tv-show/3-roses': 'V3',
	'/ca/tv-show/angel-of-death': 'V1',
	'/ca/tv-show/catching-milat': 'V2',
	'/ca/tv-show/adorazione': 'V3',
	'/ca/tv-show/american-justice': 'V1',
	'/ca/tv-show/cafe-minamdang': 'V2',
	'/ca/tv-show/davos-1917': 'V3',
	'/ca/tv-show/chosen-2022': 'V1',
	'/ca/tv-show/brene-brown-atlas-of-the-heart': 'V2',
	'/ca/tv-show/celebrity-big-brother': 'V3',
	'/ca/tv-show/dinotrux': 'V1',
	'/ca/tv-show/barbie-dreamhouse-adventures': 'V2',
	'/ca/tv-show/felix-the-cat': 'V3',
	'/ca/tv-show/fancy-nancy': 'V1',
	'/ca/tv-show/bartender': 'V2',
	'/ca/tv-show/aho-girl': 'V3',
	'/ca/tv-show/die-peanuts-classics': 'V1',
	'/ca/tv-show/celebrity-weakest-link': 'V2',
	'/ca/tv-show/comrade-detective': 'V3',
	'/ca/tv-show/express': 'V1',
	'/ca/tv-show/dark-side-of-the-2000s': 'V2',
	'/ca/tv-show/dark-shadows-1991': 'V3',
	'/ca/tv-show/13-reasons-why-beyond-the-reasons': 'V1',
	'/ca/tv-show/dream-high': 'V2',
	'/ca/tv-show/demon-king-daimao': 'V3',
	'/ca/tv-show/donkey-kong-country': 'V1',
	'/ca/tv-show/awaken': 'V2',
	'/ca/tv-show/card-captor-sakura-clear-card': 'V3',
	'/ca/tv-show/boomers': 'V1',
	'/ca/tv-show/celebrity-bear-hunt': 'V2',
	'/ca/tv-show/bad-teacher': 'V3',
	'/ca/tv-show/365-days-to-the-wedding': 'V1',
	'/ca/tv-show/bts-in-the-soop': 'V2',
	'/ca/tv-show/crazyhead': 'V3',
	'/ca/tv-show/american-gothic-2016': 'V1',
	'/ca/tv-show/bubblegum-crisis-tokyo-2040': 'V2',
	'/ca/tv-show/better-call-saul-presents-slippin-jimmy': 'V3',
	'/ca/tv-show/allegiance': 'V1',
	'/ca/tv-show/dirt': 'V2',
	'/ca/tv-show/ant-anstead-born-mechanic': 'V3',
	'/ca/tv-show/adventure-inc': 'V1',
	'/ca/tv-show/broken-promises': 'V2',
	'/ca/tv-show/dont-ever-wipe-tears-without-gloves': 'V3',
	'/ca/tv-show/dirty-lines': 'V1',
	'/ca/tv-show/best-in-miniature': 'V2',
	'/ca/tv-show/6ixtynin9-the-series': 'V3',
	'/ca/tv-show/corner-gas-animated': 'V1',
	'/ca/tv-show/cleaning-up': 'V2',
	'/ca/tv-show/ax-men': 'V3',
	'/ca/tv-show/court-of-gold': 'V1',
	'/ca/tv-show/action-team': 'V2',
	'/ca/tv-show/chopped-canada': 'V3',
	'/ca/tv-show/19-kids-and-counting': 'V1',
	'/ca/tv-show/class': 'V2',
	'/ca/tv-show/capitani': 'V3',
	'/ca/tv-show/celia': 'V1',
	'/ca/tv-show/eat-the-rich-the-gamestop-saga': 'V2',
	'/ca/tv-show/e-true-hollywood-story': 'V3',
	'/ca/tv-show/alpha-house': 'V1',
	'/ca/tv-show/chasing-life': 'V2',
	'/ca/tv-show/eternal-love': 'V3',
	'/ca/tv-show/earthsounds': 'V1',
	'/ca/tv-show/dead-still': 'V2',
	'/ca/tv-show/dragon-hunters': 'V3',
	'/ca/tv-show/el-presidente': 'V1',
	'/ca/tv-show/daughters-of-destiny': 'V2',
	'/ca/tv-show/be-my-guest-with-ina-garten': 'V3',
	'/ca/tv-show/a-guy-a-girl': 'V1',
	'/ca/tv-show/23-5': 'V2',
	'/ca/tv-show/celebrity-ex-on-the-beach': 'V3',
	'/ca/tv-show/blue-submarine-no-6': 'V1',
	'/ca/tv-show/eternelle': 'V2',
	'/ca/tv-show/camp-snoopy': 'V3',
	'/ca/tv-show/blood-machines': 'V1',
	'/ca/tv-show/father-ill-take-care-of-you': 'V2',
	'/ca/tv-show/designated-survivor-60-days': 'V3',
	'/ca/tv-show/doctors-2000': 'V1',
	'/ca/tv-show/diagnosis': 'V2',
	'/ca/tv-show/donna-leon': 'V3',
	'/ca/tv-show/avlu': 'V1',
	'/ca/tv-show/alan-davies-as-yet-untitled': 'V2',
	'/ca/tv-show/chrisley-knows-best': 'V3',
	'/ca/tv-show/buzzfeed-unsolved': 'V1',
	'/ca/tv-show/carmel-who-killed-maria-marta': 'V2',
	'/ca/tv-show/bullet-bullet': 'V3',
	'/ca/tv-show/beyond-goodbye': 'V1',
	'/ca/tv-show/arabia-kadali': 'V2',
	'/ca/tv-show/agatha-christie-lucy-worsley-on-the-mystery-queen': 'V3',
	'/ca/tv-show/bobby-kennedy-for-president': 'V1',
	'/ca/tv-show/bump-in-the-night': 'V2',
	'/ca/tv-show/dr-seusss-horton': 'V3',
	'/ca/tv-show/chief-of-staff': 'V1',
	'/ca/tv-show/7-days-out': 'V2',
	'/ca/tv-show/abraham-lincoln': 'V3',
	'/ca/tv-show/find-yourself': 'V1',
	'/ca/tv-show/engineering-catastrophes': 'V2',
	'/ca/tv-show/cinderella-chef-2018': 'V3',
	'/ca/tv-show/bambai-meri-jaan': 'V1',
	'/ca/tv-show/beautiful-reborn-flower': 'V2',
	'/ca/tv-show/captivating-the-king': 'V3',
	'/ca/tv-show/blue-dragon': 'V1',
	'/ca/tv-show/cheese-in-the-trap': 'V2',
	'/ca/tv-show/double-dare': 'V3',
	'/ca/tv-show/care-bears-adventures-in-care-a-lot': 'V1',
	'/ca/tv-show/above-average-presents': 'V2',
	'/ca/tv-show/father-brown-2013': 'V3',
	'/ca/tv-show/all-town-arent-we': 'V1',
	'/ca/tv-show/big-beasts': 'V2',
	'/ca/tv-show/falling-high-school-girl-and-irresponsible-teacher': 'V3',
	'/ca/tv-show/face-to-face': 'V1',
	'/ca/tv-show/commander-in-chief': 'V2',
	'/ca/tv-show/100-days-my-prince': 'V3',
	'/ca/tv-show/chocolate': 'V1',
	'/ca/tv-show/americas-book-of-secrets': 'V2',
	'/ca/tv-show/dinosaucers': 'V3',
	'/ca/tv-show/captivated-by-you': 'V1',
	'/ca/tv-show/crossroads-2021': 'V2',
	'/ca/tv-show/el-bronx': 'V3',
	'/ca/tv-show/beef-house': 'V1',
	'/ca/tv-show/edgemont': 'V2',
	'/ca/tv-show/ace-of-cakes': 'V3',
	'/ca/tv-show/dr-oakley-yukon-vet': 'V1',
	'/ca/tv-show/800-meters': 'V2',
	'/ca/tv-show/arthur-and-george': 'V3',
	'/ca/tv-show/cant-pay-well-take-it-away': 'V1',
	'/ca/tv-show/cesar-millan-better-human-better-dog': 'V2',
	'/ca/tv-show/action-2024': 'V3',
	'/ca/tv-show/beyond-times-gaze': 'V1',
	'/ca/tv-show/f2-forensic-factor': 'V2',
	'/ca/tv-show/chihayafuru-full-circle': 'V3',
	'/ca/tv-show/devils-line': 'V1',
	'/ca/tv-show/christian': 'V2',
	'/ca/tv-show/beelzebub': 'V3',
	'/ca/tv-show/extinct-or-alive': 'V1',
	'/ca/tv-show/action': 'V2',
	'/ca/tv-show/100-humans-lifes-questions-answered': 'V3',
	'/ca/tv-show/alone-uk': 'V1',
	'/ca/tv-show/enemy-of-the-people': 'V2',
	'/ca/tv-show/beyond-stranger-things': 'V3',
	'/ca/tv-show/crashbox': 'V1',
	'/ca/tv-show/a-very-british-coup': 'V2',
	'/ca/tv-show/bad-dinosaurs': 'V3',
	'/ca/tv-show/100-wolf-legend-of-the-moonstone': 'V1',
	'/ca/tv-show/active-shooter-america-under-fire': 'V2',
	'/ca/tv-show/culte': 'V3',
	'/ca/tv-show/2-days-and-1-night': 'V1',
	'/ca/tv-show/crims': 'V2',
	'/ca/tv-show/everyone-loves-me-2024': 'V3',
	'/ca/tv-show/casey-anthony-an-american-murder-mystery': 'V1',
	'/ca/tv-show/bolivar-una-lucha-admirable': 'V2',
	'/ca/tv-show/crownies': 'V3',
	'/ca/tv-show/defending-the-guilty': 'V1',
	'/ca/tv-show/1600-penn': 'V2',
	'/ca/tv-show/13-nights-of-elvira': 'V3',
	'/ca/tv-show/cake-wars': 'V1',
	'/ca/tv-show/ed-stafford-first-man-out': 'V2',
	'/ca/tv-show/ad-vitam': 'V3',
	'/ca/tv-show/butterfly': 'V1',
	'/ca/tv-show/20-000-leagues-under-the-sea': 'V2',
	'/ca/tv-show/criss-angel-mindfreak': 'V3',
	'/ca/tv-show/dino-dan': 'V1',
	'/ca/tv-show/bloody-game': 'V2',
	'/ca/tv-show/ex-on-the-beach-double-dutch': 'V3',
	'/ca/tv-show/a-wilderness-of-error': 'V1',
	'/ca/tv-show/fantastic-four-worlds-greatest-heroes': 'V2',
	'/ca/tv-show/42-the-answer-to-almost-everything': 'V3',
	'/ca/tv-show/all-of-us': 'V1',
	'/ca/tv-show/bts-burn-the-stage': 'V2',
	'/ca/tv-show/arsenal-military-academy': 'V3',
	'/ca/tv-show/el-candidato': 'V1',
	'/ca/tv-show/100-code': 'V2',
	'/ca/tv-show/demon-lord-2099': 'V3',
	'/ca/tv-show/cromanon': 'V1',
	'/ca/tv-show/birds-of-a-feather': 'V2',
	'/ca/tv-show/a-man-who-defies-the-world-of-bl': 'V3',
	'/ca/tv-show/chastity-high': 'V1',
	'/ca/tv-show/black-comedy': 'V2',
	'/ca/tv-show/cyborg-009-the-cyborg-soldier': 'V3',
	'/ca/tv-show/backstage': 'V1',
	'/ca/tv-show/carl-the-collector': 'V2',
	'/ca/tv-show/evermoor': 'V3',
	'/ca/tv-show/blood-river': 'V1',
	'/ca/tv-show/blackstone': 'V2',
	'/ca/tv-show/alex-vs-america': 'V3',
	'/ca/tv-show/donde-esta-marta': 'V1',
	'/ca/tv-show/bortfort': 'V2',
	'/ca/tv-show/american-odyssey': 'V3',
	'/ca/tv-show/babies': 'V1',
	'/ca/tv-show/elviras-40th-anniversary-very-scary-very-special-special': 'V2',
	'/ca/tv-show/fermont': 'V3',
	'/ca/tv-show/divided-we-stand': 'V1',
	'/ca/tv-show/extreme-sisters': 'V2',
	'/ca/tv-show/900-days-without-annabel': 'V3',
	'/ca/tv-show/chloes-closet': 'V1',
	'/ca/tv-show/basketball-wives': 'V2',
	'/ca/tv-show/elite-short-stories-carla-samuel': 'V3',
	'/ca/tv-show/babanba-banban-vampire': 'V1',
	'/ca/tv-show/detentionaire': 'V2',
	'/ca/tv-show/alien-encounters-fact-or-fiction': 'V3',
	'/ca/tv-show/captain-laserhawk-a-blood-dragon-remix': 'V1',
	'/ca/tv-show/bananas-in-pyjamas': 'V2',
	'/ca/tv-show/bucchigiri': 'V3',
	'/ca/tv-show/big-vape-the-rise-and-fall-of-juul': 'V1',
	'/ca/tv-show/dragonar-academy': 'V2',
	'/ca/tv-show/btk-confession-of-a-serial-killer': 'V3',
	'/ca/tv-show/bibi-and-tina-die-serie': 'V1',
	'/ca/tv-show/dr-seusss-red-fish-blue-fish': 'V2',
	'/ca/tv-show/class-act': 'V3',
	'/ca/tv-show/agatha-christies-hjerson': 'V1',
	'/ca/tv-show/born-to': 'V2',
	'/ca/tv-show/dive-2010': 'V3',
	'/ca/tv-show/cells-at-work-code-black': 'V1',
	'/ca/tv-show/asaf': 'V2',
	'/ca/tv-show/bbq-brawl-flay-v-symon': 'V3',
	'/ca/tv-show/avocado-toast': 'V1',
	'/ca/tv-show/critter-fixers-country-vets': 'V2',
	'/ca/tv-show/extremely-inappropriate': 'V3',
	'/ca/tv-show/denis': 'V1',
	'/ca/tv-show/drag-heals': 'V2',
	'/ca/tv-show/barneys-world': 'V3',
	'/ca/tv-show/best-mistake-2019': 'V1',
	'/ca/tv-show/detective-conan-the-culprit-hanzawa': 'V2',
	'/ca/tv-show/bonkers': 'V3',
	'/ca/tv-show/curses': 'V1',
	'/ca/tv-show/autopsy': 'V2',
	'/ca/tv-show/dice': 'V3',
	'/ca/tv-show/black-and-missing': 'V1',
	'/ca/tv-show/exception': 'V2',
	'/ca/tv-show/boy-meets-girl-2009': 'V3',
	'/ca/tv-show/escape-the-night': 'V1',
	'/ca/tv-show/boy-meets-girl': 'V2',
	'/ca/tv-show/amend-the-fight-for-america': 'V3',
	'/ca/tv-show/dream-corp-llc': 'V1',
	'/ca/tv-show/4minutes': 'V2',
	'/ca/tv-show/city-of-angels-city-of-death': 'V3',
	'/ca/tv-show/ambient-swim': 'V1',
	'/ca/tv-show/false-identity': 'V2',
	'/ca/tv-show/beachfront-bargain-hunt-renovation': 'V3',
	'/ca/tv-show/chantal': 'V1',
	'/ca/tv-show/extreme-engineering': 'V2',
	'/ca/tv-show/burn-the-house-down': 'V3',
	'/ca/tv-show/bargain-hunt': 'V1',
	'/ca/tv-show/alices-wonderland-bakery': 'V2',
	'/ca/tv-show/1000-lb-best-friends': 'V3',
	'/ca/tv-show/devon-ke-dev-mahadev': 'V1',
	'/ca/tv-show/cosby': 'V2',
	'/ca/tv-show/bread-barbershop': 'V3',
	'/ca/tv-show/beyblade-burst-surge': 'V1',
	'/ca/tv-show/24-hour-health-club': 'V2',
	'/ca/tv-show/baahubali-the-lost-legends': 'V3',
	'/ca/tv-show/drink-a-look-inside-the-glass': 'V1',
	'/ca/tv-show/eureekas-castle': 'V2',
	'/ca/tv-show/brynhildr-in-the-darkness': 'V3',
	'/ca/tv-show/do-you-wanna-partner': 'V1',
	'/ca/tv-show/boys-over-flowers-1996': 'V2',
	'/ca/tv-show/dance-in-the-vampire-bund': 'V3',
	'/ca/tv-show/black-scorpion': 'V1',
	'/ca/tv-show/bbq-pitmasters': 'V2',
	'/ca/tv-show/descendants-wicked-world': 'V3',
	'/ca/tv-show/cult-justice': 'V1',
	'/ca/tv-show/dekisokonai-to-yobareta-moto-eiyu-wa-jikka-kara-tsuihosareta-node-suki-katte-ni-ikiru-koto-ni-shita':
		'V2',
	'/ca/tv-show/blippi-wonders': 'V3',
	'/ca/tv-show/arte': 'V1',
	'/ca/tv-show/aaron-stone': 'V2',
	'/ca/tv-show/act-of-will': 'V3',
	'/ca/tv-show/f-ck1ng-social-media': 'V1',
	'/ca/tv-show/cash-cab-2008': 'V2',
	'/ca/tv-show/a-family-at-war': 'V3',
	'/ca/tv-show/8-days-that-made-rome': 'V1',
	'/ca/tv-show/el-secretario': 'V2',
	'/ca/tv-show/detective-diaries': 'V3',
	'/ca/tv-show/cromartie-high-school': 'V1',
	'/ca/tv-show/alex-inc': 'V2',
	'/ca/tv-show/devilsdorp': 'V3',
	'/ca/tv-show/all-hail-king-julien-exiled': 'V1',
	'/ca/tv-show/barbie-mysteries': 'V2',
	'/ca/tv-show/adhura': 'V3',
	'/ca/tv-show/de-brutas-nada': 'V1',
	'/ca/tv-show/a-terrified-teacher-at-ghoul-school': 'V2',
	'/ca/tv-show/arang-and-the-magistrate': 'V3',
	'/ca/tv-show/belle-and-sebastian': 'V1',
	'/ca/tv-show/camp-camp': 'V2',
	'/ca/tv-show/america-says': 'V3',
	'/ca/tv-show/american-princess': 'V1',
	'/ca/tv-show/bizarre-murders': 'V2',
	'/ca/tv-show/booze-traveler': 'V3',
	'/ca/tv-show/contraband-seized-at-the-airport': 'V1',
	'/ca/tv-show/barnwood-builders': 'V2',
	'/ca/tv-show/autumn-in-my-heart': 'V3',
	'/ca/tv-show/class-2022': 'V1',
	'/ca/tv-show/ameku-m-d-doctor-detective': 'V2',
	'/ca/tv-show/edha': 'V3',
	'/ca/tv-show/barracuda': 'V1',
	'/ca/tv-show/contraband-seized-at-sea': 'V2',
	'/ca/tv-show/date-with-the-angels': 'V3',
	'/ca/tv-show/barbie-vlogger': 'V1',
	'/ca/tv-show/duel-masters': 'V2',
	'/ca/tv-show/elias-the-little-rescue-boat': 'V3',
	'/ca/tv-show/animal': 'V1',
	'/ca/tv-show/americas-funniest-home-videos-animal-edition': 'V2',
	'/ca/tv-show/detetive-labrador': 'V3',
	'/ca/tv-show/fatal-vows': 'V1',
	'/ca/tv-show/exile': 'V2',
	'/ca/tv-show/chicken-nugget': 'V3',
	'/ca/tv-show/coast-guard': 'V1',
	'/ca/tv-show/chefs-table-france': 'V2',
	'/ca/tv-show/darwins-yearbook': 'V3',
	'/ca/tv-show/dumb-and-dumber': 'V1',
	'/ca/tv-show/dark-side-of-the-ring-after-dark': 'V2',
	'/ca/tv-show/everyone-is-doing-great': 'V3',
	'/ca/tv-show/a-girl-and-three-sweethearts': 'V1',
	'/ca/tv-show/clean-freak-aoyama-kun': 'V2',
	'/ca/tv-show/busytown-mysteries': 'V3',
	'/ca/tv-show/deadly-science': 'V1',
	'/ca/tv-show/big-school': 'V2',
	'/ca/tv-show/behaving-badly': 'V3',
	'/ca/tv-show/all-dogs-go-to-heaven-the-series': 'V1',
	'/ca/tv-show/a-woman-of-independent-means': 'V2',
	'/ca/tv-show/beauty-and-the-geek': 'V3',
	'/ca/tv-show/delete-me': 'V1',
	'/ca/tv-show/ballmastrz-9009': 'V2',
	'/ca/tv-show/broken-blade': 'V3',
	'/ca/tv-show/annie-oakley': 'V1',
	'/ca/tv-show/cutie-honey-universe': 'V2',
	'/ca/tv-show/a-gentlemans-dignity': 'V3',
	'/ca/tv-show/candid-camera-au': 'V1',
	'/ca/tv-show/archie-bunkers-place': 'V2',
	'/ca/tv-show/25-words-or-less': 'V3',
	'/ca/tv-show/city-of-dreams': 'V1',
	'/ca/tv-show/eden-2021': 'V2',
	'/ca/tv-show/drink-masters': 'V3',
	'/ca/tv-show/ana': 'V1',
	'/ca/tv-show/big-windup': 'V2',
	'/ca/tv-show/bizarre-er': 'V3',
	'/ca/tv-show/control': 'V1',
	'/ca/tv-show/all-that-2019': 'V2',
	'/ca/tv-show/cheer-squad': 'V3',
	'/ca/tv-show/big-dragon': 'V1',
	'/ca/tv-show/alan-carr-chatty-man': 'V2',
	'/ca/tv-show/ai-tenchi-muyou': 'V3',
	'/ca/tv-show/case': 'V1',
	'/ca/tv-show/el-hazard-the-magnificent-world': 'V2',
	'/ca/tv-show/breathe-into-the-shadows': 'V3',
	'/ca/tv-show/evil-kin': 'V1',
	'/ca/tv-show/doctor-finlay': 'V2',
	'/ca/tv-show/crime-investigation-australia': 'V3',
	'/ca/tv-show/class-of-92': 'V1',
	'/ca/tv-show/breathe-in-breathe-out': 'V2',
	'/ca/tv-show/alice-nevers': 'V3',
	'/ca/tv-show/bleak-house-1985': 'V1',
	'/ca/tv-show/clangers': 'V2',
	'/ca/tv-show/b-king': 'V3',
	'/ca/tv-show/brazil-with-michael-palin': 'V1',
	'/ca/tv-show/crest-of-the-stars': 'V2',
	'/ca/tv-show/a-life': 'V3',
	'/ca/tv-show/breakthrough': 'V1',
	'/ca/tv-show/caught-on-dashcam': 'V2',
	'/ca/tv-show/dick-tracy-the-lost-shows': 'V3',
	'/ca/tv-show/aquaman-king-of-atlantis': 'V1',
	'/ca/tv-show/apocalypse-hitler': 'V2',
	'/ca/tv-show/byron': 'V3',
	'/ca/tv-show/city-of-vice': 'V1',
	'/ca/tv-show/crime-inc': 'V2',
	'/ca/tv-show/feud-2025': 'V3',
	'/ca/tv-show/building-baeumler': 'V1',
	'/ca/tv-show/1994-2019': 'V2',
	'/ca/tv-show/deadliest-journeys': 'V3',
	'/ca/tv-show/dating-unlocked': 'V1',
	'/ca/tv-show/dears': 'V2',
	'/ca/tv-show/dolly-partons-heartstrings': 'V3',
	'/ca/tv-show/cancer-the-emperor-of-all-maladies': 'V1',
	'/ca/tv-show/call-me-bae': 'V2',
	'/ca/tv-show/eva-luna': 'V3',
	'/ca/tv-show/children-of-the-cult': 'V1',
	'/ca/tv-show/amazon-music-live': 'V2',
	'/ca/tv-show/dead-in-the-water': 'V3',
	'/ca/tv-show/deltora-quest': 'V1',
	'/ca/tv-show/dead2me': 'V2',
	'/ca/tv-show/chris-tarrant-extreme-railways': 'V3',
	'/ca/tv-show/band-of-gold': 'V1',
	'/ca/tv-show/acca-13-territory-inspection-dept': 'V2',
	'/ca/tv-show/air-master': 'V3',
	'/ca/tv-show/bang-dream': 'V1',
	'/ca/tv-show/accidentally-on-purpose': 'V2',
	'/ca/tv-show/davey-and-goliath': 'V3',
	'/ca/tv-show/caitlins-way': 'V1',
	'/ca/tv-show/beetle-bailey': 'V2',
	'/ca/tv-show/breaking-homicide': 'V3',
	'/ca/tv-show/bones-of-crows-the-series': 'V1',
	'/ca/tv-show/celebrity-ghost-stories': 'V2',
	'/ca/tv-show/deadliest-catch-dungeon-cove': 'V3',
	'/ca/tv-show/crush': 'V1',
	'/ca/tv-show/beast-of-bangalore-indian-predator': 'V2',
	'/ca/tv-show/birdie-buddy': 'V3',
	'/ca/tv-show/bayside-shakedown': 'V1',
	'/ca/tv-show/a-difficult-woman': 'V2',
	'/ca/tv-show/bake-squad': 'V3',
	'/ca/tv-show/cooku-with-comali': 'V1',
	'/ca/tv-show/black-space': 'V2',
	'/ca/tv-show/chemins-decole-chemins-de-tous-les-dangers': 'V3',
	'/ca/tv-show/crime-diaries-the-candidate': 'V1',
	'/ca/tv-show/dungeon-people': 'V2',
	'/ca/tv-show/ancient-egypt-by-train': 'V3',
	'/ca/tv-show/barbie-dreamhouse-challenge': 'V1',
	'/ca/tv-show/aim-for-the-ace': 'V2',
	'/ca/tv-show/bordertown': 'V3',
	'/ca/tv-show/a-la-carte': 'V1',
	'/ca/tv-show/a-good-librarian-like-a-good-shepherd': 'V2',
	'/ca/tv-show/ben-and-kate': 'V3',
	'/ca/tv-show/como-sobrevivir-soltero': 'V1',
	'/ca/tv-show/72-dangerous-animals-asia': 'V2',
	'/ca/tv-show/crash-and-bernstein': 'V3',
	'/ca/tv-show/al-zeer-salem': 'V1',
	'/ca/tv-show/dumb-bunnies': 'V2',
	'/ca/tv-show/destinations-of-the-damned-with-zak-bagans': 'V3',
	'/ca/tv-show/au-secours-de-beatrice': 'V1',
	'/ca/tv-show/afflicted': 'V2',
	'/ca/tv-show/fight-for-glory-2024-world-series': 'V3',
	'/ca/tv-show/broke-2014': 'V1',
	'/ca/tv-show/ex-wives-of-rock': 'V2',
	'/ca/tv-show/bake-your-dream': 'V3',
	'/ca/tv-show/diya-aur-baati-hum': 'V1',
	'/ca/tv-show/bella-germania': 'V2',
	'/ca/tv-show/a-plus': 'V3',
	'/ca/tv-show/audrey-est-revenue': 'V1',
	'/ca/tv-show/dope': 'V2',
	'/ca/tv-show/aoharu-x-machinegun': 'V3',
	'/ca/tv-show/beyond-the-brush': 'V1',
	'/ca/tv-show/alaska-pd': 'V2',
	'/ca/tv-show/dirty-linen': 'V3',
	'/ca/tv-show/afsos': 'V1',
	'/ca/tv-show/a-female-student-arrives-at-the-imperial-college': 'V2',
	'/ca/tv-show/com-si-fos-ahir': 'V3',
	'/ca/tv-show/count-arthur-strong': 'V1',
	'/ca/tv-show/alien-worlds': 'V2',
	'/ca/tv-show/catherine-the-great-2015': 'V3',
	'/ca/tv-show/catscratch': 'V1',
	'/ca/tv-show/alertes': 'V2',
	'/ca/tv-show/ace-crawford-private-eye': 'V3',
	'/ca/tv-show/a-girl-named-jo': 'V1',
	'/ca/tv-show/dead-of-night-2018': 'V2',
	'/ca/tv-show/chopped-junior': 'V3',
	'/ca/tv-show/abandoned': 'V1',
	'/ca/tv-show/abigail': 'V2',
	'/ca/tv-show/comics-unleashed': 'V3',
	'/ca/tv-show/arelys-henao-canto-para-no-llorar': 'V1',
	'/ca/tv-show/cielo-grande': 'V2',
	'/ca/tv-show/america-the-beautiful-2022': 'V3',
	'/ca/tv-show/concrete-revolutio': 'V1',
	'/ca/tv-show/eken-babu': 'V2',
	'/ca/tv-show/amazing-fabio-de-luigi': 'V3',
	'/ca/tv-show/after-braveheart': 'V1',
	'/ca/tv-show/dead-north': 'V2',
	'/ca/tv-show/candy-color-paradox': 'V3',
	'/ca/tv-show/demi-lovato-dancing-with-the-devil': 'V1',
	'/ca/tv-show/cinderella-at-2am': 'V2',
	'/ca/tv-show/a-good-cop': 'V3',
	'/ca/tv-show/die-pfeiler-der-macht': 'V1',
	'/ca/tv-show/de-tattas-the-series': 'V2',
	'/ca/tv-show/being-ian': 'V3',
	'/ca/tv-show/agency': 'V1',
	'/ca/tv-show/13-hours-race-against-time': 'V2',
	'/ca/tv-show/ancient-x-files': 'V3',
	'/ca/tv-show/black-rock-shooter-dawn-fall': 'V1',
	'/ca/tv-show/brave-bang-bravern': 'V2',
	'/ca/tv-show/cheese-slices': 'V3',
	'/ca/tv-show/borat-vhs-cassette-of-material-deemed-sub-acceptable-by-kazakhstan-ministry-of-censorship-and-circumcision':
		'V1',
	'/ca/tv-show/brothers-conflict': 'V2',
	'/ca/tv-show/family-s-o-s-with-jo-frost': 'V3',
	'/ca/tv-show/dinner-for-five': 'V1',
	'/ca/tv-show/digimon-ghost-game': 'V2',
	'/ca/tv-show/because-we-forget-everything': 'V3',
	'/ca/tv-show/cinderella-game': 'V1',
	'/ca/tv-show/a-history-of-christianity': 'V2',
	'/ca/tv-show/basically-nice': 'V3',
	'/ca/tv-show/cristela': 'V1',
	'/ca/tv-show/ensam-hemma': 'V2',
	'/ca/tv-show/baking-it': 'V3',
	'/ca/tv-show/big-cat-tales': 'V1',
	'/ca/tv-show/basilisk-the-ouka-ninja-scrolls': 'V2',
	'/ca/tv-show/devils-dust': 'V3',
	'/ca/tv-show/deaf-u': 'V1',
	'/ca/tv-show/crime-patrol': 'V2',
	'/ca/tv-show/day-zero-the-series': 'V3',
	'/ca/tv-show/coming-out-colton': 'V1',
	'/ca/tv-show/dupur-thakurpo': 'V2',
	'/ca/tv-show/a-criminal-affair': 'V3',
	'/ca/tv-show/ainori-love-wagon-african-journey': 'V1',
	'/ca/tv-show/63-up': 'V2',
	'/ca/tv-show/ancient-worlds': 'V3',
	'/ca/tv-show/best-in-dough': 'V1',
	'/ca/tv-show/deep-insanity-the-lost-child': 'V2',
	'/ca/tv-show/anatomy-of-a-disaster': 'V3',
	'/ca/tv-show/a-stitch-in-time': 'V1',
	'/ca/tv-show/cops-who-kill-with-will-mellor': 'V2',
	'/ca/tv-show/birth-of-europe': 'V3',
	'/ca/tv-show/faces-of-evil': 'V1',
	'/ca/tv-show/fatal-injections': 'V2',
	'/ca/tv-show/dc-cupcakes': 'V3',
	'/ca/tv-show/beauty-newbie': 'V1',
	'/ca/tv-show/dalah-death-and-the-flowers': 'V2',
	'/ca/tv-show/beast-boy-lone-wolf': 'V3',
	'/ca/tv-show/canimals': 'V1',
	'/ca/tv-show/at-the-moment': 'V2',
	'/ca/tv-show/dustys-trail': 'V3',
	'/ca/tv-show/all-or-nothing-toronto-maple-leafs': 'V1',
	'/ca/tv-show/baba-geh': 'V2',
	'/ca/tv-show/dog-loves-books': 'V3',
	'/ca/tv-show/champions': 'V1',
	'/ca/tv-show/cochina-envidia': 'V2',
	'/ca/tv-show/call-of-the-wildman': 'V3',
	'/ca/tv-show/big-brother-reindeer-games': 'V1',
	'/ca/tv-show/calle-y-poche-sin-etiquetas': 'V2',
	'/ca/tv-show/curiosity': 'V3',
	'/ca/tv-show/akai-kodan-zillion': 'V1',
	'/ca/tv-show/club-america-vs-club-america': 'V2',
	'/ca/tv-show/dropped': 'V3',
	'/ca/tv-show/bebefinn': 'V1',
	'/ca/tv-show/be-with-me': 'V2',
	'/ca/tv-show/curious-traveler': 'V3',
	'/ca/tv-show/el-circo-de-los-muchachos': 'V1',
	'/ca/tv-show/drive-thru-history-ends-of-the-earth': 'V2',
	'/ca/tv-show/bunnytown': 'V3',
	'/ca/tv-show/avalon-tv': 'V1',
	'/ca/tv-show/1-in-7641': 'V2',
	'/ca/tv-show/a-house-divided': 'V3',
	'/ca/tv-show/assault-lily-bouquet': 'V1',
	'/ca/tv-show/eiken': 'V2',
	'/ca/tv-show/absolute-duo': 'V3',
	'/ca/tv-show/black-dog': 'V1',
	'/ca/tv-show/christmas-cookie-challenge': 'V2',
	'/ca/tv-show/dead-of-night-2013': 'V3',
	'/ca/tv-show/daphne-in-the-brilliant-blue': 'V1',
	'/ca/tv-show/dr-90210': 'V2',
	'/ca/tv-show/big-man': 'V3',
	'/ca/tv-show/caught-on-bodycam': 'V1',
	'/ca/tv-show/dream-garden': 'V2',
	'/ca/tv-show/believing-in-australia': 'V3',
	'/ca/tv-show/black-lake': 'V1',
	'/ca/tv-show/baps': 'V2',
	'/ca/tv-show/behind-bars-the-worlds-toughest-prisons': 'V3',
	'/ca/tv-show/a-romance-of-the-little-forest': 'V1',
	'/ca/tv-show/emergency-bikers': 'V2',
	'/ca/tv-show/expecting-amy': 'V3',
	'/ca/tv-show/diagnosis-unknown': 'V1',
	'/ca/tv-show/dream-of-italy': 'V2',
	'/ca/tv-show/batman-and-robin': 'V3',
	'/ca/tv-show/dogs-101': 'V1',
	'/ca/tv-show/cleaners': 'V2',
	'/ca/tv-show/dinner-club-germany': 'V3',
	'/ca/tv-show/1000-lb-roomies': 'V1',
	'/ca/tv-show/fatal-engineering': 'V2',
	'/ca/tv-show/eon-kid': 'V3',
	'/ca/tv-show/bodger-and-badger': 'V1',
	'/ca/tv-show/fboy-island-australia': 'V2',
	'/ca/tv-show/extreme-love': 'V3',
	'/ca/tv-show/cold-courage': 'V1',
	'/ca/tv-show/fightworld': 'V2',
	'/ca/tv-show/andys-safari-adventures': 'V3',
	'/ca/tv-show/casualty-24-7': 'V1',
	'/ca/tv-show/bugtime-adventures': 'V2',
	'/ca/tv-show/cocomong': 'V3',
	'/ca/tv-show/courageous-cat-and-minute-mouse': 'V1',
	'/ca/tv-show/2-dope-queens': 'V2',
	'/ca/tv-show/banged-up': 'V3',
	'/ca/tv-show/a-menina-que-matou-os-pais-a-serie': 'V1',
	'/ca/tv-show/dna-says-love-you': 'V2',
	'/ca/tv-show/corduroy': 'V3',
	'/ca/tv-show/chain-of-command': 'V1',
	'/ca/tv-show/cannonball-run-2001': 'V2',
	'/ca/tv-show/eternal-boys': 'V3',
	'/ca/tv-show/afghanistan-inside-australias-war': 'V1',
	'/ca/tv-show/brave-10': 'V2',
	'/ca/tv-show/angel-from-hell': 'V3',
	'/ca/tv-show/battle-of-the-atlantic': 'V1',
	'/ca/tv-show/filthy-house-sos': 'V2',
	'/ca/tv-show/ek-hazaaron-mein-meri-behna-hai': 'V3',
	'/ca/tv-show/daimidaler-the-sound-robot': 'V1',
	'/ca/tv-show/fill-in-the-blank': 'V2',
	'/ca/tv-show/big-little-brawlers': 'V3',
	'/ca/tv-show/adventures-in-rainbow-country': 'V1',
	'/ca/tv-show/el-bulli-historia-de-un-sueno': 'V2',
	'/ca/tv-show/derby-girl': 'V3',
	'/ca/tv-show/fermats-cuisine': 'V1',
	'/ca/tv-show/50-nuances-de-grecs': 'V2',
	'/ca/tv-show/abracadavers': 'V3',
	'/ca/tv-show/adam-in-fragments': 'V1',
	'/ca/tv-show/fernando': 'V2',
	'/ca/tv-show/blondie': 'V3',
	'/ca/tv-show/deniz-inside-my-heart': 'V1',
	'/ca/tv-show/bong-appetit': 'V2',
	'/ca/tv-show/blow-up': 'V3',
	'/ca/tv-show/classroom-crisis': 'V1',
	'/ca/tv-show/arpo-the-robot-for-all-kids': 'V2',
	'/ca/tv-show/demi-gods-and-semi-devils-2021': 'V3',
	'/ca/tv-show/down-home-fab': 'V1',
	'/ca/tv-show/andante': 'V2',
	'/ca/tv-show/before-30': 'V3',
	'/ca/tv-show/a-twist-in-the-tale': 'V1',
	'/ca/tv-show/about-sunday-night': 'V2',
	'/ca/tv-show/building-giants': 'V3',
	'/ca/tv-show/bunsen-is-a-beast': 'V1',
	'/ca/tv-show/call-your-mother': 'V2',
	'/ca/tv-show/enchantimals-tales-from-everwilde': 'V3',
	'/ca/tv-show/bad-guy': 'V1',
	'/ca/tv-show/colonial-house': 'V2',
	'/ca/tv-show/americas-mississippi': 'V3',
	'/ca/tv-show/an-ancient-love-song': 'V1',
	'/ca/tv-show/dr-t-lone-star-vet': 'V2',
	'/ca/tv-show/can-ci-pin-fangzhu-xingkong': 'V3',
	'/ca/tv-show/custom-carolina': 'V1',
	'/ca/tv-show/breaking4-faith-kipyegon-vs-the-4-minute-mile': 'V2',
	'/ca/tv-show/cinderella-chef': 'V3',
	'/ca/tv-show/akedo-ultimate-arcade-warriors': 'V1',
	'/ca/tv-show/abbys-studio': 'V2',
	'/ca/tv-show/bad-mothers': 'V3',
	'/ca/tv-show/coyote-ragtime-show': 'V1',
	'/ca/tv-show/dancing-queen-2018': 'V2',
	'/ca/tv-show/elliot-moose': 'V3',
	'/ca/tv-show/9jkl': 'V1',
	'/ca/tv-show/colosseum-the-whole-story': 'V2',
	'/ca/tv-show/because-i-want-to-talk': 'V3',
	'/ca/tv-show/bad-ink': 'V1',
	'/ca/tv-show/cestvs-the-roman-fighter': 'V2',
	'/ca/tv-show/baroque-from-st-peters-to-st-pauls': 'V3',
	'/ca/tv-show/badults': 'V1',
	'/ca/tv-show/bust-down': 'V2',
	'/ca/tv-show/ex-arm': 'V3',
	'/ca/tv-show/chef-swap-at-the-beach': 'V1',
	'/ca/tv-show/de-12-van-schouwendam': 'V2',
	'/ca/tv-show/extreme-homes': 'V3',
	'/ca/tv-show/bullets': 'V1',
	'/ca/tv-show/barney-google-and-snuffy-smith': 'V2',
	'/ca/tv-show/bronx-zoo-90-crime-chaos-and-baseball': 'V3',
	'/ca/tv-show/dry-bar-comedy': 'V1',
	'/ca/tv-show/denise-richards-and-her-wild-things': 'V2',
	'/ca/tv-show/family-game-night': 'V3',
	'/ca/tv-show/amar-e-para-os-fortes': 'V1',
	'/ca/tv-show/a-tale-of-two-cities': 'V2',
	'/ca/tv-show/double-dare-1976': 'V3',
	'/ca/tv-show/bahu-hamari-rajni-kant': 'V1',
	'/ca/tv-show/dangerous-persuasions': 'V2',
	'/ca/tv-show/ellies-real-good-food': 'V3',
	'/ca/tv-show/aarti-party': 'V1',
	'/ca/tv-show/engga-hostel': 'V2',
	'/ca/tv-show/a-perfect-crime': 'V3',
	'/ca/tv-show/bad-girlfriend': 'V1',
	'/ca/tv-show/biography-kisstory': 'V2',
	'/ca/tv-show/a-ship-through-time-secrets-of-the-newport-ship': 'V3',
	'/ca/tv-show/action-2019': 'V1',
	'/ca/tv-show/7-days-in-hell': 'V2',
	'/ca/tv-show/combat-dealers': 'V3',
	'/ca/tv-show/affairs-of-the-heart': 'V1',
	'/ca/tv-show/30-vies': 'V2',
	'/ca/tv-show/a-wedding-story': 'V3',
	'/ca/tv-show/coop-troop': 'V1',
	'/ca/tv-show/divided-states': 'V2',
	'/ca/tv-show/encouragement-of-climb-next-summit': 'V3',
	'/ca/tv-show/a-grito-herido': 'V1',
	'/ca/tv-show/barons': 'V2',
	'/ca/tv-show/coast-guard-florida': 'V3',
	'/ca/tv-show/beauty-of-resilience': 'V1',
	'/ca/tv-show/abandoned-expedition-shipwreck': 'V2',
	'/ca/tv-show/a-taste-of-south-africa': 'V3',
	'/ca/tv-show/evergreen': 'V1',
	'/ca/tv-show/celebrity-beef': 'V2',
	'/ca/tv-show/coin-digger': 'V3',
	'/ca/tv-show/enemies-the-president-justice-and-the-fbi': 'V1',
	'/ca/tv-show/5th-ward': 'V2',
	'/ca/tv-show/amanza': 'V3',
	'/ca/tv-show/atelier': 'V1',
	'/ca/tv-show/evidence-of-murder': 'V2',
	'/ca/tv-show/against-our-destiny': 'V3',
	'/ca/tv-show/buckingham-palace-with-alexander-armstrong': 'V1',
	'/ca/tv-show/cosmic-vistas': 'V2',
	'/ca/tv-show/blow-breeze': 'V3',
	'/ca/tv-show/esports-world-cup-level-up': 'V1',
	'/ca/tv-show/ai-hui-lai': 'V2',
	'/ca/tv-show/a-little-reunion': 'V3',
	'/ca/tv-show/a-dark-dark-man': 'V1',
	'/ca/tv-show/dive-olly-dive': 'V2',
	'/ca/tv-show/atelier-escha-and-logy-alchemists-of-the-dusk-sky': 'V3',
	'/ca/tv-show/bake-or-break': 'V1',
	'/ca/tv-show/create-together': 'V2',
	'/ca/tv-show/bichikids': 'V3',
	'/ca/tv-show/fantasista-doll': 'V1',
	'/ca/tv-show/brews-brothers': 'V2',
	'/ca/tv-show/chavorrucos': 'V3',
	'/ca/tv-show/30-days-with-ryan-garcia': 'V1',
	'/ca/tv-show/cool-stuff-how-it-works': 'V2',
	'/ca/tv-show/dancing-queen': 'V3',
	'/ca/tv-show/akkad-bakkad-rafu-chakkar': 'V1',
	'/ca/tv-show/dd-fist-of-the-north-star': 'V2',
	'/ca/tv-show/almost-lover': 'V3',
	'/ca/tv-show/fabulous-lives-of-bollywood-wives': 'V1',
	'/ca/tv-show/family-recipe-showdown': 'V2',
	'/ca/tv-show/conspiracy-2019': 'V3',
	'/ca/tv-show/big-food-truck-tip': 'V1',
	'/ca/tv-show/body-of-evidence': 'V2',
	'/ca/tv-show/burger-land': 'V3',
	'/ca/tv-show/committed': 'V1',
	'/ca/tv-show/dok-go-bin-is-updating': 'V2',
	'/ca/tv-show/fall-in-love-with-him': 'V3',
	'/ca/tv-show/autumn-cicada': 'V1',
	'/ca/tv-show/all-about-secrets': 'V2',
	'/ca/tv-show/dahab-ghali': 'V3',
	'/ca/tv-show/agi-bagi': 'V1',
	'/ca/tv-show/ancient-roads-from-christ-to-constantine': 'V2',
	'/ca/tv-show/4th-and-long': 'V3',
	'/ca/tv-show/9-years-of-you': 'V1',
	'/ca/tv-show/battles-bc': 'V2',
	'/ca/tv-show/big-bad-bbq-brawl': 'V3',
	'/ca/tv-show/dna-mate': 'V1',
	'/ca/tv-show/falling-for-challenge': 'V2',
	'/ca/tv-show/50-facons-de-tuer-sa-mere': 'V3',
	'/ca/tv-show/chase-street': 'V1',
	'/ca/tv-show/dance-champions': 'V2',
	'/ca/tv-show/al-daheeh-museum': 'V3',
	'/ca/tv-show/a-town-called-victoria': 'V1',
	'/ca/tv-show/americas-supernanny': 'V2',
	'/ca/tv-show/college-hill-celebrity-edition': 'V3',
	'/ca/tv-show/a-place-called-hollywood': 'V1',
	'/ca/tv-show/comedy-island-thailand': 'V2',
	'/ca/tv-show/el-novicio-rebelde': 'V3',
	'/ca/tv-show/dream-deals': 'V1',
	'/ca/tv-show/barmageddon': 'V2',
	'/ca/tv-show/captain-planet-with-don-cheadle': 'V3',
	'/ca/tv-show/7th-street-theater': 'V1',
	'/ca/tv-show/a-billion-to-one': 'V2',
	'/ca/tv-show/a-boss-and-a-babe': 'V3',
	'/ca/tv-show/a-matter-of-justice': 'V1',
	'/ca/tv-show/a-sale-of-two-cities': 'V2',
	'/ca/tv-show/aaron-needs-a-job': 'V3',
	'/ca/tv-show/acting-out': 'V1',
	'/ca/tv-show/addani-alayb': 'V2',
	'/ca/tv-show/adult-ed': 'V3',
	'/ca/tv-show/after-the-rush': 'V1',
	'/ca/tv-show/all-talk': 'V2',
	'/ca/tv-show/american-takedown': 'V3',
	'/ca/tv-show/aoki-vampires-trouble': 'V1',
	'/ca/tv-show/authentic-living': 'V2',
	'/ca/tv-show/borg-mom': 'V3',
	'/ca/tv-show/desperate-measures': 'V1',
	'/ca/tv-show/dogfights': 'V2',
	'/ca/tv-show/everybody-loves-natti': 'V3',
	'/ca/tv-show/cheese-a-love-story': 'V1',
	'/ca/tv-show/celebrity-food-fight': 'V2',
	'/ca/tv-show/dog-detectives': 'V3',
};

export default metaDescriptionVariantTitles;
